/// <reference path="../_references.js" />
/// <reference path="../_references.js" />

if (isNullOrUndefined(veritracks.enrollees.mapping)) {
    veritracks.enrollees.mapping = {};
}

veritracks.enrollees.mapping.data = ({
    'PrimaryCardList': [],
    'PrimaryRequest': -999,
    'SecondaryCardList': [],
    'SecondaryRequest': -999,
    'VisitCardList': [],
    'TagCardList': [],
    'EnrolleesLoading': 0,
    'IsLocked': false,
    'IsTracking': false,
    'DoGeocode': false,
    'DoDistanceCalculation': false,
    'DoAddHomeAddress': false,
    'ExportData': null,
    'DisplayVisitCount': false,
    'DoFitBounds': true,
    'PreviousZoom': 0,
    'CurrentCardType': 0,
    'VisitTrackPointCount': 0,
    'LookAheadCardList': [],
    'TimeChangeTimerId': null,
    'RequestIds': {
        'PrimaryTripVisit': null,
        'SecondaryTripVisit': null
    }
});
(function(mapping){
    function hasORIPropperty(){
        var flag = false;
        var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
        if(lEnrollee != null)
            flag = checkOrganizationProperty(lEnrollee.OrganizationId, "enable_trackreviews_recording");
        if(flag =='R'){
            flag = true;
        }else {
            flag = false
        }
        return flag;
    }
    mapping.ORIFlag = function (){
        var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
        var ORIPropertyTrackReview =  'N'; // Default
        if(lEnrollee != null){
            ORIPropertyTrackReview = checkOrganizationProperty(lEnrollee.OrganizationId, "enable_trackreviews_recording");
        }
        return ORIPropertyTrackReview;
    }
        
    /**
     * getLockState
     */
    mapping.getLockState = function(){
        var lPreferenceMapTimeLock = getViewState('MapTimeLock'),
        lPreferenceMapTimeLockTracking = getViewState('MapTimeTracking');

        if(hasORIPropperty()){
            if (!isNullOrUndefined(lPreferenceMapTimeLock) && !isNullOrUndefined(lPreferenceMapTimeLockTracking)){
                if(lPreferenceMapTimeLock.Value && !lPreferenceMapTimeLockTracking.Value){
                    mapping.setLock(lPreferenceMapTimeLock.Value);
                }else if (lPreferenceMapTimeLock.Value && lPreferenceMapTimeLockTracking.Value){
                    mapping.lockAndRecord();
                }else{
                    mapping.unlock();
                }
            }else { 
                mapping.unlock();
            }
        }else { 
            if (!isNullOrUndefined(lPreferenceMapTimeLock)) {
                mapping.setLock(lPreferenceMapTimeLock.Value);
            }else { 
                mapping.unlock();
            }
        }
    };
    mapping.mapLockClick  = function(){
        var lDateRange = offenderMapPopulate_GetDateRange(false),
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem();
        if(hasORIPropperty()){
            // On click 
            var lAgentsStopCheck = getDataItem(gUserDetails.UserId, 'Users');
            var lTrackCount = CalculateTrackpointCount();
            var lVisitCount = CalculateVisitCount();
            var lCardCount = 0;
            if (!isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView)) {
                lCardCount = mEnrolleesControls.OffenderTrackpointDetailCardView.getDataSource().length;
                //if card view is not empty get gps points only
                if (lCardCount > 0) {
                    lCardCount = lVisitCount.Count + lTrackCount;
                }
            }
           
            if (mapping.data.IsLocked && !mapping.data.IsTracking) {
                mEnrolleesData.LockedOffender = lEnrollee.Id;
                mapping.lockAndRecord();
                if (lAgentsStopCheck) {
                    var lTransactionDate = new Date(moment());
                    logUserTransaction(mEnrolleesData.OffenderCurrentId, 1, gUserDetails.UserId, mEnrolleesData.EnrolleesMapTransactionStartDate, mEnrolleesData.EnrolleesMapTransactionStopDate, lTransactionDate,null, lCardCount);
                }
            } else if (mapping.data.IsLocked && mapping.data.IsTracking){
                mEnrolleesData.LockedOffender = lEnrollee.Id;
                if (lAgentsStopCheck) {
                    var lTransactionDate = new Date(moment());
                    logUserTransaction(mEnrolleesData.OffenderCurrentId, 5, gUserDetails.UserId, mEnrolleesData.EnrolleesMapTransactionStartDate, mEnrolleesData.EnrolleesMapTransactionStopDate, lTransactionDate,null, lCardCount);
                }
                mapping.unlock();
            }else { 
                // In case is not Locked and 
                mEnrolleesData.LockedOffender = lEnrollee.Id;
                mEnrolleesData.LockFeatureEndSaveState = null;
                mEnrolleesData.LockFeatureStartSaveState = null;
                mEnrolleesData.LockedOffender = null;
                mapping.lock();
            }
        }else {
            if(mapping.data.IsLocked){
                mapping.unlock();
            } else{
                mEnrolleesData.LockFeatureStartSaveState = null;
                mEnrolleesData.LockedOffender = null;
                mEnrolleesData.LockFeatureEndSaveState = null;
                mapping.lock();
            }
        }
    };
    mapping.getMapTimeLockTrackingState = function(){
        var lPreferenceMapTimeLock = getViewState('MapTimeLock'),
        lLockData ={lock:false,tracking:false};
        lPreferenceMapTimeLockTracking = getViewState('MapTimeTracking');
        if (!isNullOrUndefined(lPreferenceMapTimeLock)) {
            lLockData.lock = lPreferenceMapTimeLock.Value;
        }
        if ( !isNullOrUndefined(lPreferenceMapTimeLockTracking)){
            lLockData.tracking = lPreferenceMapTimeLockTracking.Value;
        }
        return lLockData;
    }
    /**
     * setSate
     * @param name  Name of the User Preference to set the state e.g.  'TimeRecorder' 
     * @param value  Boolean  enable or disable e.g.true
     */
    function setSate(name,value){
        var lPreference = new UserPreference();
        lPreference.ColumnName = name;
        lPreference.Id = gUserDetails.UserId;
        lPreference.UserPreferenceType = 4;
        lPreference.Value = value.toString();
        writeUserPreferences([lPreference]);
        setViewState(name, value);
    }
    /**
     * setDatePickerDisabled
     * @param value  Boolean  enable or disable
     */
    function setDatePickerDisabled(value){
        $('#uMapStartDatePicker').prop('disabled', value);
        $('#uMapStartTimePicker').prop('disabled', value);
        $('#uEnrolleeMapTimeFilter').prop('disabled', value);
        if (!value) {
            if ($('#uMapStartDatePicker').hasClass('DatePickerDisabled')) {
                $('#uMapStartDatePicker').removeClass('DatePickerDisabled');
            }
            if ($('#uMapStartTimePicker').hasClass('DatePickerDisabled')) {
                $('#uMapStartTimePicker').removeClass('DatePickerDisabled');
            }
            if ($('#uEnrolleeMapTimeFilter').hasClass('DatePickerDisabled')) {
                $('#uEnrolleeMapTimeFilter').removeClass('DatePickerDisabled');
            }
        } else {
            if (!$('#uMapStartDatePicker').hasClass('DatePickerDisabled')) {
                $('#uMapStartDatePicker').addClass('DatePickerDisabled');
            }
            if (!$('#uMapStartTimePicker').hasClass('DatePickerDisabled')) {
                $('#uMapStartTimePicker').addClass('DatePickerDisabled');
            }
            if (!$('#uEnrolleeMapTimeFilter').hasClass('DatePickerDisabled')) {
                $('#uEnrolleeMapTimeFilter').addClass('DatePickerDisabled');
            }
            
        }
    }
    /**
     * unlock the map datepicker 
     * Also automatically sets a state 'MapTimeLock' 
     */
    mapping.unlock = function(){
        setSate('MapTimeLock', false);
        mapping.data.IsLocked = false;
        if(hasORIPropperty()){
            mapping.data.IsTracking = false;
            setSate('MapTimeTracking', false);

        }
        setDatePickerDisabled(false);
        mapping.displayLock();
    };
    /**
     * lock the map datepicker 
     * Also automatically sets a state 'MapTimeLock' 
     * 
     */
    mapping.lock = function(){
        setSate('MapTimeLock', true);
        setDatePickerDisabled(true);
        mapping.data.IsLocked = true;
        if(hasORIPropperty()){
            mapping.data.IsTracking = false;
        }
        mapping.displayLock();
    };
    /**
     * lock the map datepicker and start tracking user tansaction
     * Also automatically sets a state 'MapTimeLock' and MapTimeTracking
     * Only on ORI Propperty On
     * 
     */
    mapping.lockAndRecord = function(){
        setSate('MapTimeLock', true);
        setDatePickerDisabled(true);
        mapping.data.IsLocked = true;
        if(hasORIPropperty()){
            setSate('MapTimeTracking', true);
            mapping.data.IsTracking = true;
        }
        mapping.displayLock();
    };

    mapping.setLock = function (aValue) {
        "use strict";
        if(aValue){
            this.lock();
        }else {
            this.unlock();
        }
    }
    mapping.displayLock = function () {
        "use strict";
        function lockedStartEndText(){
            var lDateRange = offenderMapPopulate_GetDateRange();
            var lEnrollee = GetEnrollee(mEnrolleesData.LockedOffender),
                lLockedStartDate,
                lLockedEndDate;
            if (isNullOrUndefined(mEnrolleesData.LockFeatureEndSaveState)) {
                lLockedStartDate = DisplayShortDateTime(lDateRange.startDate);
                lLockedEndDate = DisplayShortDateTime(lDateRange.endDate);
                mEnrolleesData.LockFeatureEndSaveState = lLockedEndDate;
                mEnrolleesData.LockFeatureStartSaveState = lLockedStartDate;
            }else {
                lLockedEndDate = mEnrolleesData.LockFeatureEndSaveState;
                lLockedStartDate = mEnrolleesData.LockFeatureStartSaveState;
            }
            return 'Start: ' + lLockedStartDate + ' - End: ' + lLockedEndDate;
        }
        if(hasORIPropperty()){
            if (mapping.data.IsLocked && !mapping.data.IsTracking) {
                $('#uMapLockButton').addClass('Unlock');
                $('#uMapLockButton').addClass('IsLocked').attr('title',lockedStartEndText());
                setDatePickerDisabled(true);
            } else if (mapping.data.IsLocked && mapping.data.IsTracking ){
                $('#uMapLockButton').addClass('IsLocked');
                $('#uMapLockButton').addClass('IsTracking').attr('title','Tracking... '+lockedStartEndText());
                setDatePickerDisabled(true);
            }else {
                // In case is not Locked and 
                $('#uMapLockButton').removeClass('Unlock');
                $('#uMapLockButton').removeClass('IsLocked');
                $('#uMapLockButton').removeClass('IsTracking');
                setDatePickerDisabled(false);
            }
        }else { 
            if (mapping.data.IsLocked) {
                $('#uMapLockButton').addClass('Unlock');
                $('#uMapLockButton').addClass('IsLocked').attr('title',lockedStartEndText());
                setDatePickerDisabled(true);
            } else {
                $('#uMapLockButton').removeClass('IsTracking');
                $('#uMapLockButton').removeClass('Unlock')
                $('#uMapLockButton').removeClass('IsLocked').attr('title', 'lock');
                setDatePickerDisabled(false);
                
            }
        }
    };

})(veritracks.enrollees.mapping);
veritracks.enrollees.mapping.PreviousZoom = function (aPreviousZoom) {
    veritracks.enrollees.mapping.data.PreviousZoom = aPreviousZoom;
};

veritracks.enrollees.mapping.CurrentCardType = function (cardType) {
    veritracks.enrollees.mapping.data.CurrentCardType = cardType;
};

veritracks.enrollees.mapping.AddToTotalVisitCardList = function (aCardList) {
    "use strict";
    var lKey;

    for (lKey in aCardList) {
        if (aCardList.hasOwnProperty(lKey)) {
            if (!isNullOrUndefined(veritracks.enrollees.mapping.data.VisitCardList)) {
                veritracks.enrollees.mapping.data.VisitCardList.push(aCardList[lKey]);
            }
            else {
                veritracks.enrollees.mapping.data.VisitCardList = aCardList[lKey];
            }
        }
    }
};

veritracks.enrollees.mapping.RemoveFromTotalVisitCardList = function (aCardList) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lHolder = [],
        lQuery,
        lKey;
    if (ObjectLength(aCardList) != ObjectLength(veritracks.enrollees.mapping.data.VisitCardList)) {
        for (lKey in aCardList) {
            if (aCardList.hasOwnProperty(lKey)) {
                lHolder.push('t' + aCardList[lKey].Id);
            }
        }

        lBuilder.AddNewExpressionConditional('Id', lHolder, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
        lQuery = query(veritracks.enrollees.mapping.data.VisitCardList, lBuilder.RootExpression);
        veritracks.enrollees.mapping.data.VisitCardList = lQuery;
    }
    else {
        veritracks.enrollees.mapping.data.VisitCardList = [];
    }


}

veritracks.enrollees.mapping.CleanOffenderPastData = function () {
    "use strict";
    var lKey,
        lKeyB,
        lHolder,
        lCleanOffenderPastData = [];

    for (lKey in mEnrolleesData.OffenderPastData) {
        if (mEnrolleesData.OffenderPastData.hasOwnProperty(lKey)) {
            lHolder = mEnrolleesData.OffenderPastData[lKey];
            if ($.isArray(lHolder)) {
                for (lKey in lHolder) {
                    if (lHolder.hasOwnProperty(lKey)) {
                        lHolder[lKey].IsExpanded = true;
                        lCleanOffenderPastData.push(lHolder[lKey]);
                    }
                }
            }
            else {
                lHolder.IsExpanded = true;
                lCleanOffenderPastData.push(lHolder);
            }
        }
    }
    mEnrolleesData.OffenderPastData = lCleanOffenderPastData;
}
veritracks.enrollees.mapping.generateAddressCard = function (aAddress, aEnrollee, aEnrolleePosition) {
    "use strict";
    var lCard = new MapCard(),
        lTrackItem,
        lTimeZone = getTimezone(aEnrollee.TimeZoneId, 'TimeZone'),
        lIsInformatics = false;
    if (!isNullOrUndefined(aEnrollee)) {
        lIsInformatics = getInformaticsEnabled(aEnrollee.OrganizationId);
    }
       
    lTrackItem = veritracks.mapping.prepareAddressItem(aAddress, aEnrolleePosition);
    if (!isNullOrUndefined(lTrackItem)) {
        lCard.Id = 'a' + aAddress.Id.toString();
        lCard.Type = 1;
        lCard.SortOrder = 1;
        lCard.GsmSignalStrength = -1;
        lCard.ViewPanoramaSetting = 'StreetViewIcon';
        lCard.Name = aAddress.Title;
        lCard.Latitude = aAddress.Latitude.toString().substring(0, 9);
        lCard.Longitude = aAddress.Longitude.toString().substring(0, 9);
        lCard.EnrolleeName = aEnrollee.FullName;
        lCard.Date = lCard.SortDate;
        lCard.Detail = aAddress.Street1;
        lCard.Address = aAddress.Street1;
        if (aAddress.Street2 !== '') {
            lCard.Detail2 = aAddress.Street2;
            lCard.Address += ' ' + aAddress.Street2;
        }
        lCard.Detail3 = [
            aAddress.City,', ',aAddress.State, ' ', aAddress.Zip.toString(),
        ].join(' ');
        lCard.Detail4 = [
            'Created at:',displayEnrolleeTimeZone(fixDate(aAddress.CreatedDateUTC),lTimeZone),'</br>',
            'Updated at:',displayEnrolleeTimeZone(fixDate(aAddress.UpdatedUTC),lTimeZone)
        ].join(' ');
        // lCard.Detail3 = aAddress.City + ', ' + aAddress.State + ' ' + aAddress.Zip.toString();
        lCard.Address += ' ' + lCard.Detail3;
        lCard.IsGeocoded = true;
        lCard.TrackItem = lTrackItem;        
        if (lIsInformatics) {
            lCard.SVGMarker = lTrackItem.SVGMarker;
            lCard.iconUri = lTrackItem.iconUri;
            lCard.SVGDisplay = 'block';
            lCard.MarkerSingleIcon = 'table-row-group';
        }
        lCard.IconClass = 'Track' + lTrackItem.cardViewClass;
    } else {
        lCard = null;
    }
    return lCard;
};

veritracks.enrollees.mapping.generateZoneCard = function (aZoneItem, aVertices, aEnrolleeId) {
    "use strict";
    var lCard = new MapCard(),
        lEnrollee = getDataItem(aEnrolleeId, 'Enrollees'),
        lZone;
    lZone = aZoneItem.data;
    lCard.Id = 'z' + lZone.Id;
    lCard.Type = 2;
    lCard.SortOrder = 2;
    lCard.TrackItem = aZoneItem;
    lCard.EnrolleeId = aEnrolleeId;
    lCard.ViewPanoramaSetting = 'StreetViewIconDisabled';
    lCard.EnrolleeName = lEnrollee.FullName;
    lCard.EnrolleeFirstName = lEnrollee.FirstName;
    lCard.EnrolleeLastName = lEnrollee.LastName;
    lCard.Name = lZone.Name;
    lCard.GsmSignalStrength = -1;
    lCard.IconClass = 'Zone';
    lCard.Latitude = lZone.CenterLatitude.toString().substring(0, 9);
    lCard.Longitude = lZone.CenterLongitude.toString().substring(0, 9);
    if (!isNullOrUndefined(aVertices)) {
        lCard.Vertices = aVertices;
    }
    lCard.Date = lCard.SortDate;
    lCard.Detail = lZone.Description;
    lCard.Address = '- no address available -';
    if (lZone.Radius > 1000) {
        lCard.isMapped = false;
    }
    lCard.ZoneRadius = lZone.Radius;
    lCard.ExtendedDetail = veritracks.mapping.generateCardDetailProperty('Type', zoneTypeFormatter(lZone.Type)) + veritracks.mapping.generateCardDetailProperty('Scope', zoneScopeFormatter(lZone.Scope));

    return lCard;
};

veritracks.enrollees.mapping.generateVisitCard = function (aVisit, aEnrollee, aAddress, aEnrolleePosition, aAssociation, aHasMapEvents) {
    "use strict";
    var lCard = new MapCard(),
        lTimezone = getTimezone(aEnrollee.TimeZoneId),
        lTrackItem,
        lHasEventsConfirmed,
        lEnrollee =  getDataItem(mEnrolleesData.OffenderCurrentId !== -1 ?mEnrolleesData.OffenderCurrentId : mEnrolleesData.VictimCurrentId, 'Enrollees'),
        lIsInformatics = false;

    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
        
    if (aVisit.IsCurrent) {
        lCard.Id = 'v-' + aEnrolleePosition.toString();
        lCard.Name = localizeText('cEnrolleesMappingInProgress');
    } else {
        lCard.Id = 'v' + aVisit.Id.toString() + aVisit.StartDate.getTime().toString();
        lCard.Name = localizeText('cEnrolleesMappingVisit');
        lCard.Detail2 = localizeWrapper('cEnrolleesMappingEnd') + ' ' + displayEnrolleeTimeZoneFormatted(aVisit.EndDateUTC, lTimezone);
    }
    lCard.AssociationCard = '';
    lCard.HasMapEvents = aHasMapEvents;
    lCard.VisitId = aVisit.Id;
    lCard.Type = 3;
    lCard.ViewPanoramaSetting = 'StreetViewIcon';
    lCard.SortOrder = 3;
    lCard.Date = aVisit.StartDate;
    lCard.SortDate = getMoment(aVisit.EndDateUTC);
    lCard.GsmSignalStrength = -1;
    lCard.Latitude = aVisit.Latitude.toString().substring(0, 9);
    lCard.Longitude = aVisit.Longitude.toString().substring(0, 9);
    lCard.Detail = localizeWrapper('cEnrolleesMappingStart') + ' ' + displayEnrolleeTimeZoneFormatted(aVisit.StartDateUTC, lTimezone);
    if (aVisit.TrackPointCount > 0) {
        lCard.ExtendedDetail = veritracks.mapping.generateCardDetailProperty(localizeWrapper('cEnrolleesMappingTrackpointCount'), aVisit.TrackPointCount);
        if (aVisit.IsCountCalculated) {
            lCard.SecondExtendedDetail = veritracks.mapping.generateCardDetailSecondProperty(localizeWrapper('cEnrolleesMappingTrackpointCountTruncated'));
        }
    }

    lTrackItem = veritracks.mapping.prepareVisitItem(aVisit, aEnrolleePosition, aAssociation);
    lCard.TrackItem = lTrackItem;
    lCard.EnrolleeId = aEnrollee.Id;
    lCard.EnrolleeName = aEnrollee.FullName;
    lCard.EnrolleeFirstName = aEnrollee.FirstName;
    lCard.EnrolleeLastName = aEnrollee.LastName;   
    if (lIsInformatics) {
        lCard.SVGMarker = lTrackItem.SVGMarker;
        lCard.iconUri = lTrackItem.iconUri;
        lCard.SVGDisplay = 'block';
        lCard.MarkerSingleIcon = 'table-row-group';
    }
    lCard.IconClass = 'Track' + lTrackItem.cardViewClass;
    if (!isNullOrUndefined(aAddress)) {
        lCard.Address = aAddress.Description;
        lCard.IsGeocoded = true;
    } else {
        lCard.Address = localizeWrapper('cEnrolleesMappingUnknown');
    }
    lCard.AddressId = lCard.TrackItem.data.AddressId;
    // used for retrieving OffenderPastData on refresh where you want to have visits remain expanded.
    if (!isNullOrUndefined(mEnrolleesData.OffenderPastData)) {
        var lBuilder = new SumoPredicateBuilder(),
            lQuery;

        lBuilder.AddNewExpressionConditional('VisitId', lCard.VisitId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
        lBuilder.AddNewExpressionConditional('IsExpanded', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('Id', lCard.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
        lQuery = query(mEnrolleesData.OffenderPastData, lBuilder.RootExpression);

        if (lQuery.length > 0) {
            lCard.IsExpanded = true;
        }
    }
    if (aAssociation && lIsInformatics) {
        lCard.Association = aAssociation;
        if (lIsInformatics == false) {
            lCard.TrackItem.iconUri = 'Images/Maps/Trackpoints/' + aEnrolleePosition + '0400000Association.png';
        }
        
        if (aAssociation.OrganizationAddressId > 0) {
            if (checkValidOrganizationAddress(aAssociation.OrganizationAddressId)) {
                if (lIsInformatics == false) {
                    lCard.TrackItem.iconUri = 'Images/Maps/Trackpoints/' + aEnrolleePosition + '0400000AssociationKnownLocation.png';
                }
                
                lCard.IsAssociationVisit = true;
                lCard.CorrelationAtKnownLocation = 'block';
                lCard.AssociationCard = 'KnownLocation'; 
            } else {
                lCard.CorrelateDisplay = 'block';
                lCard.AssociationCard = 'Association';
            }
        } else {
            lCard.CorrelateDisplay = 'block';
            lCard.AssociationCard = 'Association';
        }
    }
    if (!isNullOrUndefined(lCard.HasMapEvents)) {
        if (lCard.HasMapEvents) {
            lHasEventsConfirmed = veritracks.mapping.hasEventsConfirmed(lCard, aVisit);
            if (lHasEventsConfirmed) {
                lCard.GenericMapEvents = 'block';
            }
            else {
                lCard.GenericMapEvents = 'none'
            }
        }
    }

    return lCard;
};

veritracks.enrollees.mapping.generateTrackpointCard = function (aTrackpoint, aType, aEnrollee, aEnrolleePosition) {
    "use strict";
    var lCard = new MapCard(),
        lTimezone = getTimezone(aEnrollee.TimeZoneId),
        lEnrollee = getDataItem(aEnrollee.Id, 'Enrollees'),
        lIsInformatics = false,       
        lTrackItem;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
    
    lCard.Id = 't' + aTrackpoint.Id;
    lCard.Type = aType;
    lCard.SortOrder = 3;
    if (aType === 32) {
        aTrackpoint.TrackTypeId = 32;
    }
    lCard.Name = localizeText('cEnrolleesMappingTrackpoint');
    lCard.EnrolleeId = aEnrollee.Id;
    lCard.EnrolleePosition = aEnrolleePosition;
    lCard.EnrolleeName = aEnrollee.FullName;
    lCard.ViewPanoramaSetting = 'StreetViewIcon';
    lCard.GsmSignalStrength = Math.floor(aTrackpoint.GsmSignal / 6);
    if (lCard.GsmSignalStrength === 5) {
        lCard.GsmSignalStrength = 4;
    } else if (lCard.GsmSignalStrength === 4) {
        lCard.GsmSignalStrength = 3;
    } else if (lCard.GsmSignalStrength === 3) {
        lCard.GsmSignalStrength = 2;
    } else if (lCard.GsmSignalStrength === 2) {
        lCard.GsmSignalStrength = 1;
    } else if (lCard.GsmSignalStrength === 1) {
        lCard.GsmSignalStrength = 0;
    }
    
    lTrackItem = veritracks.mapping.prepareTrackpointMarkerItem(aTrackpoint, aEnrolleePosition);
    lCard.TrackItem = lTrackItem;

    lCard.IconClass = 'Track' + lTrackItem.cardViewClass;
    lCard.Date = aTrackpoint.TrackDate    
    if (lIsInformatics) {
        lCard.SVGMarker = lTrackItem.SVGMarker;
        lCard.iconUri = lTrackItem.iconUri;
        lCard.SVGDisplay = 'block';
        lCard.MarkerSingleIcon = 'table-row-group';
    }
    lCard.SortDate = getMoment(aTrackpoint.TrackDateUTC);
    switch (aTrackpoint.TrackTypeId) {
        case 1:
        case 2:
            lCard.Latitude = aTrackpoint.Latitude.toString().substring(0, 9);
            lCard.Longitude = aTrackpoint.Longitude.toString().substring(0, 9);
            break;
        case 3:
            lCard.Latitude = aTrackpoint.CellTowerLatitude;
            lCard.Longitude = aTrackpoint.CellTowerLongitude;
            // cell tower fix
            lCard.Type = 8;
			break;
		case 9:
			lCard.Latitude = aTrackpoint.Latitude;
			lCard.Longitude = aTrackpoint.Longitude;
			// WiFi fix
			lCard.Type = 9;
            break;
        case 25:
            lCard.Latitude = aTrackpoint.Latitude.toString().substring(0, 9);
            lCard.Longitude = aTrackpoint.Longitude.toString().substring(0, 9);
            break;
        case 31:
            lCard.Latitude = aTrackpoint.Latitude;
            lCard.Longitude = aTrackpoint.Longitude;
            lCard.Type = 31;
            break;
        case 33:
            lCard.Latitude = aTrackpoint.Latitude;
            lCard.Longitude = aTrackpoint.Longitude;
            lCard.Type = 33;
            break; 
        case 61:
            lCard.Latitude = aTrackpoint.Latitude.toString().substring(0, 9);
            lCard.Longitude = aTrackpoint.Longitude.toString().substring(0, 9);
            lCard.Type = 61;
            break;
    }
    lCard.Detail = displayEnrolleeTimeZoneFormatted(aTrackpoint.TrackDateUTC, lTimezone);
    lCard.InventoryBatteryClass = 'InventoryBattery' + getBatteryIcon(aTrackpoint.BatteryLevel);
    lCard.InventorySignalClass = 'InventoryBattery' + getBatteryIcon(aTrackpoint.BatteryLevel);
    lCard.GsmSignalStrengthClass = 'InventoryGsmSignal' + lCard.GsmSignalStrength;
    lCard.ExtendedDetail = veritracks.mapping.trackpointGenerateCardDetail(aTrackpoint);

    return lCard;
};

veritracks.enrollees.mapping.generateTagCard = function (aTag) {
    "use strict";
    var lCard = new MapCard(),
        lTrackItem;

    lCard.Id = 'l' + aTag.Id;
    lCard.Type = 6;
    lCard.SortOrder = 0;
    lCard.TagId = aTag.Id;
    lCard.ViewPanoramaSetting = 'StreetViewIcon';
    lCard.Name = aTag.Name;
    lCard.IconClass = 'Tag';
    lCard.GsmSignalStrength = -1;
    lCard.Latitude = aTag.Latitude.toString().substring(0, 9);
    lCard.Longitude = aTag.Longitude.toString().substring(0, 9);
    lCard.Detail = 'Label';
    lCard.Detail2 = localizeText('cUserUpdatedBy') + ': ' + UserNameTagFormatter(aTag.UserId);
    lCard.EditDisplay = '';

    lTrackItem = veritracks.mapping.prepareTrackpointMarkerItem(aTag);
    lCard.TrackItem = lTrackItem;

    return lCard;
};

function CalculateVisitCount() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList),
        lTotalVisitCount = 0,
        lIsInProgress = false;

    lBuilder.AddNewExpressionConditional('SortOrder', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Type', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lData = query(lData, lBuilder.RootExpression);
    lTotalVisitCount = ObjectLength(lData);

    if (lTotalVisitCount == 1) {
        for (var lKey in lData) {
            if (lData.hasOwnProperty(lKey)) {
                lIsInProgress = lData[lKey].TrackItem.data.IsCurrent;
            }
        }
    }

    return { 'Count': lTotalVisitCount, 'InProgress': lIsInProgress };
}
function CalculateTrackpointCount() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
    lData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList),
    lTotalTrackPointCount = 0;

    lBuilder.AddNewExpressionConditional('SortOrder', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Type', 5, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lData = query(lData, lBuilder.RootExpression);
    lTotalTrackPointCount = ObjectLength(lData);

    return lTotalTrackPointCount;
}

function CalculateAllPlaybackTracksPoints() {
    "use strict";

    var lBuilder = new SumoPredicateBuilder(),
    lData,
    lTotalTrackPointCount = 0;

    if (mStateManager.Settings()[0] == 'Offenders') {
        lData = mEnrolleesControls.OffenderTrackpointDetailCardView.getDataSource();
    } else {
        lData = mEnrolleesControls.VictimTrackpointDetailCardView.getDataSource();
    }
    //trackpoints except address and zones
    lBuilder.AddNewExpressionConditional('SortOrder', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Type', 1, false, mRelationalOperatorEnum.IsNot(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Type', 2, false, mRelationalOperatorEnum.IsNot(), mLogicalOperatorEnum.And());
    lData = query(lData, lBuilder.RootExpression);
    lTotalTrackPointCount = ObjectLength(lData);

    return lTotalTrackPointCount;

}

function CalculateVisitTrackPointCount(aExpand) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList),
        lTotalTrackPointCount = 0,
        lExpand = aExpand,
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),        
        lKey;

    lBuilder.AddNewExpressionConditional('VisitId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lData = query(lData, lBuilder.RootExpression);

    if (lData.length > 0) {
        for (lKey in lData) {
            if (lData.hasOwnProperty(lKey)) {               
                 lTotalTrackPointCount += lData[lKey].TrackItem.data.TrackPointCount;            
                
            }
        }

        if (lTotalTrackPointCount <= 2880) {
            $('#uExpandAllButton').show();
            if ($('#uExpandAllButton').hasClass('Selected') && lExpand) {
                mEnrolleesData.VisitsProcesssed = false;
                uShowVisitPoints_ExpandVisits();
            }
        }
        else {
            $('#uExpandAllButton').hide();
        }
    }
    else {
        $('#uExpandAllButton').hide();
    }

    return lTotalTrackPointCount;
}

veritracks.enrollees.mapping.initializeNextDay = function (aEnrolleeId, aEnrolleePosition, aStartTime, aEndTime) {
    "use strict";
    var lEnrollee = getDataItem(aEnrolleeId, "Enrollees"),
        lFullCardList = [],
        lPreferences = getUserPreferences(4),       
        lPreference,        
        lValue = 1;

    if (isNullOrUndefined(lEnrollee)) {
        lEnrollee = getDataItem(aEnrolleeId, 'EnrolleesUniversal');
    }

    
    veritracks.mapping.data.EnumeratedIcons = [];

    $('#uMapBackButton').addClass('Disabled');

    var lHistoryTrackStartDate = veritracks.system.clientSetting('HistoryTrackStartDate');
    var lIsHistoricalDate = false;
    if (!isNullOrUndefined(lHistoryTrackStartDate)) {
        if (aStartTime < lHistoryTrackStartDate) {
            lIsHistoricalDate = true;
        }
    }

    function nextVisit_Init() {
        veritracks.mapping.readTripsVisits(aEnrolleeId, lIsHistoricalDate, aStartTime, aEndTime, false, nextVisit_OnComplete, nextVisit_OnFail, {});
    }

    function nextVisit_OnComplete(aParams, aData) {
        "use strict";
        if (ObjectLength(aData) > 0)
            veritracks.enrollees.mapping.AssignLookAheadData(aEnrolleeId, aStartTime, aEndTime, aData);

        $('#uMapBackButton').removeClass('Disabled');
    }

    function nextVisit_OnFail() {

    }

    function nextTrackpoint_Init() {
        veritracks.mapping.readTrackpointsProc(aEnrolleeId, lIsHistoricalDate, aStartTime, aEndTime, nextTrackpoint_OnComplete, nextTrackpoint_OnFail, {});
    }

    function nextTrackpoint_OnComplete(aParams, aData) {
        "use strict";

        if (ObjectLength(aData) > 0)
            veritracks.enrollees.mapping.AssignLookAheadData(aEnrolleeId, aStartTime, aEndTime, aData);

        $('#uMapBackButton').removeClass('Disabled');
    }

    function nextTrackpoint_OnFail() {

    }

    function begin() {
        var lBuilder,
            lPreviousDayList,
            lPreviousData;

        lPreviousDayList = veritracks.enrollees.mapping.data.LookAheadCardList

        if (ObjectLength(lPreviousDayList) > 0)
            lPreviousData = veritracks.enrollees.mapping.NextDayData(aEnrolleeId, aStartTime, aEndTime);

        lPreference = lPreferences['TrackType'];
        if (!isNullOrUndefined(lPreference)) {
            lValue = parseInt(lPreference.Value, 10);
        }

        if (isNullOrUndefined(lPreviousData) || ObjectLength(lPreviousData) == 0) {
            if (lValue === 1 && mStateManager.Settings()[0] === 'Offenders') {
                nextVisit_Init();
            } else {
                nextTrackpoint_Init();
            }
        }
        else {
            $('#uMapBackButton').removeClass('Disabled');
        }
    }

    begin();
};

// assign to look ahead
veritracks.enrollees.mapping.AssignLookAheadData = function (aEnrolleeId, aStartTime, aEndTime, aData) {
    "use strict";
    var lData;

    if (ObjectLength(aData) > 0)
        lData = new LookAheadItem(aEnrolleeId, aStartTime, aEndTime, aData);

    if (!isNullOrUndefined(lData)) {
        veritracks.enrollees.mapping.data.LookAheadCardList.push(lData);
    }
}

veritracks.enrollees.mapping.NextDayData = function (aEnrolleeId, aStartTime, aEndTime) {
    "use strict";
    var lLookAheadItemList,
        lGroupingLastStartDate = null,
        lData;

    lLookAheadItemList = veritracks.enrollees.mapping.data.LookAheadCardList;

    for (var lKey in lLookAheadItemList) {
        if (lLookAheadItemList.hasOwnProperty(lKey)) {
            if (+aStartTime == +lLookAheadItemList[lKey].StartTime && +aEndTime == +lLookAheadItemList[lKey].EndTime && aEnrolleeId == lLookAheadItemList[lKey].EnrolleeId) {
                lData = lLookAheadItemList[lKey];                
            }
        }
    }       

    return lData;
}

veritracks.enrollees.mapping.initialize = function (aEnrolleeId, aEnrolleePosition, aStartTime, aEndTime, aUpdateFlag, aFinishedCallBack) {
    "use strict";
    var lEnrollee = getDataItem(aEnrolleeId, 'Enrollees'),
        lReadsRemaining = 6,
        lFullCardList = [],
        mRequestId = gRequestManager.getRequestId(),
        lPreferences = getUserPreferences(4),
        lSelectedCard = mEnrolleesControls.CardView.selectedDataItem(),
        lPreference,
        lUpdateFlag = false,
        lUpdatedContact = null,
        lValue = 1;

    if (mStateManager.Settings()[0] == 'Victims') {
        if (lEnrollee.EnrolleeType == 1)
            lReadsRemaining = 3;
        else
            lReadsRemaining = 1;
    }

    var lAgentsStopCheck = getDataItem(gUserDetails.UserId, 'Users');

    if (lAgentsStopCheck) {
        if (mEnrolleesData.EnrolleesMapTransactionStartDate == null && mEnrolleesData.EnrolleesMapTransactionStopDate == null) {
            var lTransactionContactDate = null;
            if (!isNullOrUndefined(lSelectedCard.LastContactDate)) {
                lTransactionContactDate = lSelectedCard.LastContactDate;
            }

            mEnrolleesData.EnrolleesMapTransactionStartDate = aStartTime;
            mEnrolleesData.EnrolleesMapTransactionStopDate = aEndTime;
            logUserTransaction(aEnrolleeId, 1, gUserDetails.UserId, aStartTime, aEndTime, lTransactionContactDate);
            logUserTransaction(aEnrolleeId, 5, gUserDetails.UserId, aStartTime, aEndTime, lTransactionContactDate, true);

        } else {
            logUserTransaction(aEnrolleeId, 5, gUserDetails.UserId, mEnrolleesData.EnrolleesMapTransactionStartDate, mEnrolleesData.EnrolleesMapTransactionStopDate, lTransactionContactDate);
            mEnrolleesData.EnrolleesMapTransactionStartDate = aStartTime;
            mEnrolleesData.EnrolleesMapTransactionStopDate = aEndTime;
            logUserTransaction(aEnrolleeId, 1, gUserDetails.UserId, aStartTime, aEndTime, lTransactionContactDate);
            logUserTransaction(aEnrolleeId, 5, gUserDetails.UserId, aStartTime, aEndTime, lTransactionContactDate, true);
        }
    }
    

    if (isNullOrUndefined(lEnrollee)) {
        lEnrollee = getDataItem(aEnrolleeId, 'EnrolleesUniversal');
    }

    if (!isNullOrUndefined(aUpdateFlag))
        lUpdateFlag = aUpdateFlag;
    // EVENTS
    function data_OnInitialized() {
        if ((aEnrolleePosition === 1 && veritracks.enrollees.mapping.data.PrimaryRequest === mRequestId) || veritracks.enrollees.mapping.data.SecondaryRequest === mRequestId) {
            if (aEnrolleePosition === 1) {
                veritracks.enrollees.mapping.data.PrimaryCardList = lFullCardList;
            } else {
                veritracks.enrollees.mapping.data.SecondaryCardList = lFullCardList;
            }
           
        }
        
        if (--veritracks.enrollees.mapping.data.EnrolleesLoading === 0) {
            setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false);
            $('.MapFilter').show();
            //ie8 fix
            if ($('#ie').hasClass('ie8')) {
                $('#uEnrolleesMapButtonContentOverheadBar').show();
            }
            if (gUserDetails.Role == 2) {
                $('#uShowTrackPointEventsButton').hide();
            }
            if (mStateManager.Settings()[0] === 'Offenders') {
                mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
            } else {
                mEnrolleesControls.VictimTrackpointDetailCardViewFilter.filter();
            }
            if (mEnrolleesData.IsExpandedAllVisits) {
                $('#uExpandAllButton').addClass('Selected');
            }
            PreserveExpandedVisits(aEnrolleeId);
            var lTrackPointCount = CalculateVisitTrackPointCount(true);

            if (aUpdateFlag && aEnrolleePosition == 1) {
                FixSpeedLastContact_Updater(lUpdatedContact);
                var lNextDay = offenderMapPopulateNextDay_GetDateRange(aEndTime);
                if (lNextDay.IsValid)
                    veritracks.enrollees.mapping.initializeNextDay(aEnrolleeId, 1, lNextDay.startDate, lNextDay.endDate);
            }
            if(aFinishedCallBack){
                aFinishedCallBack();
            }
        }
    }


    function PreserveExpandedVisits(aEnrolleeId) {
        "use strict";
        var lEnrolleeId = aEnrolleeId,
            lBuilder = new SumoPredicateBuilder(),
            lSame = false,
            lKey,
            lKeyB,
            lHolder,
            lMapCard = [];

        if (!$('#uExpandAllButton').hasClass('Selected')) {

            lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lMapCard = query(mEnrolleesData.OffenderPastData, lBuilder.RootExpression);
            mEnrolleesData.OffenderPastData = [];

            if (ObjectLength(lMapCard) >= 1) {
                for (lKey in lMapCard) {
                    if (lMapCard.hasOwnProperty(lKey)) {
                        veritracks.enrollees.mapping.expandVisit(lMapCard[lKey]);
                    }
                }
            }
        }
    }
    //Addresses
    function address_OnFail(aParams, a, b, c) {

    }

    function address_OnComplete(aParams, aAddressList) {
        var lCardList = [],
        lCard,
        lItem,
        lKey;
        mEnrolleesData.OffenderProfileAddresses = [];
        for (lKey in aAddressList) {
            if (aAddressList.hasOwnProperty(lKey)) {
                lItem = aAddressList[lKey];
                mEnrolleesData.OffenderProfileAddresses[lItem.Id] = lItem;
                lCard = veritracks.enrollees.mapping.generateAddressCard(lItem, lEnrollee, aEnrolleePosition);
                if (!isNullOrUndefined(lCard)) {
                    lCardList.push(lCard);
                }
            }
        }
        lFullCardList = lFullCardList.concat(lCardList);
        if (--lReadsRemaining === 0) {
            data_OnInitialized();
        }
    }

    function address_Init() {
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, address_OnComplete, address_OnFail, {}, null, 0, true);
    }

    // Zones
    function zone_OnComplete(aParams, aData, aVertices) {
        var lCardList = [],
            lItem,
            lKey;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                lCardList.push(veritracks.enrollees.mapping.generateZoneCard(lItem, aVertices[lItem.data.Id], aEnrolleeId));
            }
        }

        lFullCardList = lFullCardList.concat(lCardList);
        if (--lReadsRemaining === 0) {
            data_OnInitialized();
        }
    }

    function zone_Init() {
        var lBuilder = new SumoPredicateBuilder(),
            lSchedules = mEnrolleesData.OffenderSchedules,
            lZoneList = getDataItems('Zones'),
            lZoneIds = [],
            lZones = [],
            lZone,
            lItem,
            lKey;

        lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        if (!isNullOrUndefined(lZoneList)) {
            lSchedules = query(lSchedules, lBuilder.RootExpression);
            for (lKey in lSchedules) {
                if (lSchedules.hasOwnProperty(lKey)) {
                    lItem = lSchedules[lKey];
                    if (lZoneIds.indexOf(lItem.EntityId) === -1) {
                        lZone = lZoneList[lItem.EntityId];
                        if (!isNullOrUndefined(lZone) && lZone.IsVisible) {
                            lZoneIds.push(lItem.EntityId);
                            if (!isNullOrUndefined(lZone)) {
                                lZones.push(lZone);
                            }
                        }
                    }
                }
            }
            veritracks.mapping.renderZones(mEnrolleesControls.EnrolleesMap, 'Zones', lZones, zone_OnComplete, {});
        } else {
            zone_OnComplete(null, [], []);
        }
    }

    // Visits
    function tag_OnFail(aParams, a, b, c) {

    }

    function visitTag_OnSuccess(aParams, aData) {
        var lCardList = [],
            lKey,
            lCard,
            lItem;
        if (aData.length > 0) {

            for (lKey in aData) {
                if (aData.hasOwnProperty(lKey)) {
                    lItem = aData[lKey];
                    lCard = veritracks.enrollees.mapping.generateTagCard(lItem);
                    lCardList[lItem.Id] = lCard;
                }
            }
            veritracks.enrollees.mapping.data.TagCardList = lCardList;
            lFullCardList = lFullCardList.concat(lCardList);

        }

        if (--lReadsRemaining === 0) {
            data_OnInitialized();
        }
    }

    function tag_OnComplete(aParams, aData) {
        var lCardList,
            lVisitFilter,
            lBuilder = new SumoPredicateBuilder(),
            lTagIdList = [],
            lVisit,
            lTag,
            lItem,
            lKey;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                lTagIdList.push(lItem.TagId);

                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('VisitId', lItem.VisitId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lVisitFilter = query(lFullCardList, lBuilder.RootExpression);
                if (lVisitFilter.length > 0) {
                    lVisit = lVisitFilter[lVisitFilter.length - 1];
                    if (!isNullOrUndefined(lVisit)) {
                        lVisit.Detail3 = 'Tag: ' + lItem.Name;
                    }
                }
            }
        }

        if (lTagIdList.length > 0) {
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('Id', lTagIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.Tag.AssemblyQualifiedName, lBuilder.RootExpression, 0, visitTag_OnSuccess, Sad);
        } else {
            visitTag_OnSuccess(null, []);
        }
    }

    function visitAddress_OnFail(aParams, a, b, c) {

    }

    function EnrolleeCorrelationMatch_OnSuccess(aParams, aData) {
        "use strict";
        var lPointGroupingIds = [],
            lHasEventstoConfirmList = [],
            lAssociation,
            lCardList = [];

        for (var key in aParams) {
            if (aParams.hasOwnProperty(key)) {
                lAssociation = null;
                for (var lkey in aData) {
                    if (aData.hasOwnProperty(lkey)) {
                        if (aData[lkey]) {
                            if (aData[lkey].PointGroupingId == aParams[key].PointGroupingItem.Id) {
                                lAssociation = aData[lkey];
                            }
                        }
                    }
                }
                lCardList.push(veritracks.enrollees.mapping.generateVisitCard(aParams[key].PointGroupingItem, aParams[key].Enrollee, aParams[key].Item, aParams[key].EnrolleePosition, lAssociation, aParams[key].HasMapEvents));
            }
        }//end of for

        lFullCardList = lFullCardList.concat(lCardList);

        if (--lReadsRemaining === 0) {
            data_OnInitialized();
        } 
    }

    function visitAddress_OnComplete(aParams, aData) {
        var lDoDisplayCellPoints = veritracks.system.clientSetting('MapDisplayCellCentroids'),
            lCardList = [],
            lVisitIdList = [],
            lPointGroupingItem,
            lPointGroupingKey,
            lAddresses = [],
			lInProgressCount = 0,
            lPointItem,
            lPointKey,
            lCardType,
            lDisplayVisitCount = false,
            lDevice,
            lBuilder,
            lItem,
            lKey,
            lVisitItems = [],
            lHasMapEvents;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                lAddresses[lItem.Id] = lItem;
            }
        }

        for (lPointGroupingKey in aParams) {
            if (aParams.hasOwnProperty(lPointGroupingKey)) {
                lItem = null;
                lPointGroupingItem = aParams[lPointGroupingKey];
                if (lPointGroupingItem.Id === -1) {
                    ++lInProgressCount;
                    lPointGroupingItem.Id = lPointGroupingItem.Id * lInProgressCount;
                }

                if (!lDisplayVisitCount) {
                    lDevice = getDataItem(lPointGroupingItem.DeviceId, 'Devices');
                    if (!isNullOrUndefined(lDevice)) {
                        lDisplayVisitCount = (lDevice.ProductId !== 110);
                    }
                    else {
                        lDisplayVisitCount = true;
                    }
                }
                                
                if (lPointGroupingItem.Type === 1) {
                    var lLatestDate = new Date("1970/1/12");   
                    var lBplKey = -1;
                    var lBpPoint = null;
                    var lVTackCount = 0;
                    // trip
                    for (lPointKey in lPointGroupingItem.Trackpoints) {
                        if (lPointGroupingItem.Trackpoints.hasOwnProperty(lPointKey)) {
                            lPointItem = lPointGroupingItem.Trackpoints[lPointKey];
							if (lPointItem.Latitude !== 0 && lPointItem.Longitude !== 0) {
								FixDates(lPointItem);
								switch (lPointItem.TrackTypeId) {
									case 1:
										lCardType = 5;
										break;
									case 2:
										lCardType = 8;
										break;
									case 3:
										lCardType = 9;
										break;
								}
								var lpbLastContact = gEnrolleeLastContact[lPointItem.EnrolleeId];
								if (lpbLastContact) {
									var lbpDevice = getDataItem(lpbLastContact.DeviceId, 'Devices');

									//bluplus last track before sleep
									if (!isNullOrUndefined(lbpDevice) && lbpDevice.ProductId == 110 && lPointItem.HmuExpStatus == 2) {
										if (lPointItem.TrackDate > lLatestDate) {
											lBplKey = lVTackCount;
											lLatestDate = lPointItem.TrackDate;
											lBpPoint = $.extend({}, lPointItem);
										}
									}
								}

								//this is just for debugging will remove after radius is implemented
								//if(lPointItem.TrackTypeId === 9) {
								//	lPointItem.radiusOfWifi = 25;
								//}

                                lCardList.push(veritracks.enrollees.mapping.generateTrackpointCard(lPointItem, lCardType, lEnrollee, aEnrolleePosition));                                                              
                                lVTackCount++;
                            }
                        }
                    }
                   
                    if (lBplKey != -1) { 
                        mEnrolleesData.EnrolleeBPLTBS = lBpPoint;
                        lBpPoint.TrackTypeId = 25;                          
                        lCardList[lBplKey] = veritracks.enrollees.mapping.generateTrackpointCard(lBpPoint, 5, lEnrollee, aEnrolleePosition);
                    
                    }
                } else {
                    // visit
                    //has events on visit or trackpoint
                    lHasMapEvents = veritracks.mapping.visitTrackpointEvents(lPointGroupingItem);
                    lVisitIdList.push(lPointGroupingItem.Id);
                    if (lPointGroupingItem.AddressId !== -1) {
                        lItem = lAddresses[lPointGroupingItem.AddressId];
                    }
                    lVisitItems.push({ 'PointGroupingItem': lPointGroupingItem, 'Enrollee': lEnrollee, 'Item': lItem, 'EnrolleePosition': aEnrolleePosition, 'HasMapEvents': lHasMapEvents });
                    //lCardList.push(veritracks.enrollees.mapping.generateVisitCard(lPointGroupingItem, lEnrollee, lItem, aEnrolleePosition));
                }
            }
        }
        veritracks.enrollees.mapping.data.DisplayVisitCount = lDisplayVisitCount;
        lFullCardList = lFullCardList.concat(lCardList);
       
        if (lVisitIdList.length > 0) {
            var lKey;
            for (lKey in lVisitIdList) {
                if (lVisitIdList.hasOwnProperty(lKey)) {
                    if (lVisitIdList[lKey] == 0) {
                        lVisitIdList.splice(lKey, 1);
                    }
                }
            }
            if (lVisitIdList.length > 0) {
                lBuilder = new SumoPredicateBuilder();
                lBuilder.AddNewExpressionConditional('VisitId', lVisitIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                ReadMultiple(gObjectList.TagVisitLink.AssemblyQualifiedName, lBuilder.RootExpression, 0, tag_OnComplete, tag_OnFail, {}, null, 0);
            } else {
                if (--lReadsRemaining === 0) {
                    data_OnInitialized();
                }
            }
        } else {
            if (--lReadsRemaining === 0) {
                data_OnInitialized();
            }
        }
       
        getBluPlusLastTrack(aParams);
        getEnrolleeAssociationMatches(aEnrolleeId, EnrolleeCorrelationMatch_OnSuccess, lVisitItems);
    }

    function getBluPlusLastTrack(aParams) {
        "use strict";
        var lpbLastContact,
            lbpDevice;

        lpbLastContact = gEnrolleeLastContact[aEnrolleeId];

        if (isNullOrUndefined(lpbLastContact)) {
            if (--lReadsRemaining === 0) {
                data_OnInitialized();
            }
            return null;
        }

        lbpDevice = getDataItem(lpbLastContact.DeviceId, 'Devices');

        if (mEnrolleesData.EnrolleeBPLTBS != null || (lbpDevice != null && lbpDevice.ProductId != 110)) {
            if (--lReadsRemaining === 0) {
                data_OnInitialized();
            }
            return null;
        }       
        veritracks.mapping.readTrackpointsProc(aEnrolleeId, false, aStartTime, aEndTime, true, bluplustracks_OnSuccess, visit_OnFail, {});       
    }

    function bluplustracks_OnSuccess(aParams, aData) {
        "use strict";
        var lCardList = [],
            lLastKey = -1,
            lLatestDate = new Date("1970/1/12"),          
            lCardType = 5;
        

        for (var key in aData.Trackpoints) {
            if (aData.Trackpoints.hasOwnProperty(key)) {
                var lItem = aData.Trackpoints[key];
                if (lItem.HmuExpStatus == 2) {
                    FixDates(lItem); 
                    if (lItem.TrackDate > lLatestDate) {
                        lLatestDate = lItem.TrackDate;
                        lLastKey = key;
                    }                    
                }                
            }
        }

        if (lLastKey != -1) {
            var lItem = aData.Trackpoints[lLastKey];
            mEnrolleesData.EnrolleeBPLTBS = lItem;
            FixDates(lItem);            
            lItem.TrackTypeId = 25;
            lCardList.push(veritracks.enrollees.mapping.generateTrackpointCard(lItem, 5, lEnrollee, 1));           
        }

        lFullCardList = lFullCardList.concat(lCardList);

        if (--lReadsRemaining === 0) {
            data_OnInitialized();
        }
    }

    function visit_OnFail(aParams, a, b, c) {

    }

    function visit_OnComplete(aParams, aData, aExtraData) {
        var lBuilder,
            lAddressIdHash = [],
            lAddressIds = [],
            lData = aData.Groupings,
            lExtraData = aExtraData,
            lItem,
            lKey;

        if (aUpdateFlag) {
            FixDates(lExtraData);
            lUpdatedContact = lExtraData;
        }

        if (lEnrollee.EnrolleeType == 1) {
            address_OnComplete(aParams, aData.Addresses)
        }
        if (aEnrolleePosition == 1) {
            veritracks.enrollees.mapping.data.RequestIds.PrimaryTripVisit = null;
        } else {
            veritracks.enrollees.mapping.data.RequestIds.SecondaryTripVisit = null;
        }

        //if(isNullOrUndefined(veritracks.enrollees.mapping.NextDayData(aEnrolleeId, aStartTime, aEndTime)))
        //    veritracks.enrollees.mapping.AssignLookAheadData(aEnrolleeId, aStartTime, aEndTime, aData);
        veritracks.enrollees.mapping.data.VisitTrackPointCount = 0;
        FixDates(lData);
        for (lKey in lData) {
            if (lData.hasOwnProperty(lKey)) {
                lItem = lData[lKey];
                if (lItem.AddressId !== -1 && isNullOrUndefined(lAddressIdHash[lItem.AddressId])) {
                    lAddressIds.push(lItem.AddressId);
                    lAddressIdHash[lItem.AddressId] = 1;
                }
                veritracks.enrollees.mapping.data.VisitTrackPointCount += lItem.TrackPointCount;
            }
        }
        if (lAddressIds.length > 0) {
            var lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('Id', lAddressIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.Address.AssemblyQualifiedName, lBuilder.RootExpression, 0, visitAddress_OnComplete, visitAddress_OnFail, lData, null, 0, true);
        } else {
            visitAddress_OnComplete(lData, []);
        }
    }

    function visit_Init() {
        var lHistoryTrackStartDate = veritracks.system.clientSetting('HistoryTrackStartDate');
        var lIsHistoricalDate = false;
        if (!isNullOrUndefined(lHistoryTrackStartDate)) {
            if (aStartTime < lHistoryTrackStartDate) {
                lIsHistoricalDate = true;
            }
        }
        var lRequestId = veritracks.mapping.readTripsVisits(aEnrolleeId, lIsHistoricalDate, aStartTime, aEndTime, aUpdateFlag, visit_OnComplete, visit_OnFail, {});
        if (aEnrolleePosition === 1) {
            if (veritracks.enrollees.mapping.data.RequestIds.PrimaryTripVisit !== null) {
                veritracks.data.controller.cancelRequest(veritracks.enrollees.mapping.data.RequestIds.PrimaryTripVisit);
                veritracks.enrollees.mapping.data.RequestIds.PrimaryTripVisit = null;
                veritracks.enrollees.mapping.data.EnrolleesLoading -= 1;
            }
            veritracks.enrollees.mapping.data.RequestIds.PrimaryTripVisit = lRequestId;
        } else {
            if (veritracks.enrollees.mapping.data.RequestIds.SecondaryTripVisit !== null) {
                veritracks.data.controller.cancelRequest(veritracks.enrollees.mapping.data.RequestIds.SecondaryTripVisit);
                veritracks.enrollees.mapping.data.RequestIds.SecondaryTripVisit = null;
                veritracks.enrollees.mapping.data.EnrolleesLoading -= 1;
            }
            veritracks.enrollees.mapping.data.RequestIds.SecondaryTripVisit = lRequestId;
        }
    }

    function trackpoint_OnFail(aParams, a, b, c) {

    }

    function trackpoint_OnComplete(aParams, aData) {
        var lCardList = [],
            lCard,
            lItem,
            lKey;

        var lTrackpoints = aData.Trackpoints;

        if (isNullOrUndefined(veritracks.enrollees.mapping.NextDayData(aEnrolleeId, aStartTime, aEndTime)))
            veritracks.enrollees.mapping.AssignLookAheadData(aEnrolleeId, aStartTime, aEndTime, lTrackpoints);
        
        if (mStateManager.Settings()[0] !== 'Victims' && lEnrollee.EnrolleeType == 1) {
            address_OnComplete(aParams, aData.Addresses)
        }
        

        FixDates(lTrackpoints);
        for (lKey in lTrackpoints) {
            if (lTrackpoints.hasOwnProperty(lKey)) {
                lItem = lTrackpoints[lKey];
                if (lItem.HmuExpStatus == 2) {
                    mEnrolleesData.EnrolleeBPLTBS = lItem;
                    lItem.TrackTypeId = 25;
                    lCard = veritracks.enrollees.mapping.generateTrackpointCard(lItem, 5, lEnrollee, aEnrolleePosition);
                } else {
                    lCard = veritracks.enrollees.mapping.generateTrackpointCard(lItem, 5, lEnrollee, aEnrolleePosition);
                }
                
                if (!isNullOrUndefined(lCard)) {
                    lCardList.push(lCard);
                }
            }
        }
        lFullCardList = lFullCardList.concat(lCardList);
        if (--lReadsRemaining === 0) {
            data_OnInitialized();
        }
    }

    function trackpoint_Init() {
        var lHistoryTrackStartDate = veritracks.system.clientSetting('HistoryTrackStartDate');
        var lIsHistoricalDate = false;
        if (!isNullOrUndefined(lHistoryTrackStartDate)) {
            if (aStartTime < lHistoryTrackStartDate) {
                lIsHistoricalDate = true;
            }
        }
        veritracks.mapping.readTrackpointsProc(aEnrolleeId, lIsHistoricalDate, aStartTime, aEndTime, true, trackpoint_OnComplete, trackpoint_OnFail, {});
    }

    function CardViewLocation_Init() {
        var lIsCaseLoadVisible = false,
            lPreference = new UserPreference(),
            lUserPreferences = getUserPreferences(4);

        // using user preferences caseload to save state.
        if (!isNullOrUndefined(lUserPreferences['IsCaseLoadVisible'])) {
            lIsCaseLoadVisible = (lUserPreferences['IsCaseLoadVisible'].Value === 'true');
        }
        if (lIsCaseLoadVisible) {
            if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap)) {
                mEnrolleesControls.EnrolleesMap.layerSetDataSource('CaseLoad', veritracks.mapping.prepareTrackpointMarkerData(mEnrolleesData.LastLocationByCardView));
                mEnrolleesControls.EnrolleesMap.layerSetDataSource('CaseLoadLabels', veritracks.mapping.prepareSuggestionLabelOverlayData(mEnrolleesData.LastLocationByCardView));

                mEnrolleesControls.EnrolleesMap.layerShow('CaseLoad');
                mEnrolleesControls.EnrolleesMap.layerShow('CaseLoadLabels');
                $('#uToggleAllLastKnownPointsButton').addClass('Selected');
                $('#uToggleAllLastKnownPointsButton').attr('title', localizeTitleFormatter('remove all last known positions'));
            }
        } else {
            if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap)) {
                mEnrolleesControls.EnrolleesMap.layerHide('CaseLoad');
                mEnrolleesControls.EnrolleesMap.layerHide('CaseLoadLabels');
                $('#uToggleAllLastKnownPointsButton').removeClass('Selected');
                $('#uToggleAllLastKnownPointsButton').attr('title', localizeTitleFormatter('toggle all last known positions'));
            }
        }
    }

    function alcohol_OnFailure(aParams, a, b, c) {
        "use strict";

    }

    function alcoholTest_OnInitialized(aDataList) {
        "use strict";
        lFullCardList = lFullCardList.concat(aDataList);
        if (--lReadsRemaining === 0) {
            data_OnInitialized();
        }
    }

    // INITIALIZE
    function begin() {
        var lLookAheadData;

        if (aEnrolleePosition === 1) {
            veritracks.enrollees.mapping.data.PrimaryRequest = mRequestId;
        } else {
            veritracks.enrollees.mapping.data.SecondaryRequest = mRequestId;
        }

        // if data is here then this should be pretty quick.
        if (!isNullOrUndefined(veritracks.enrollees.mapping.data.LookAheadCardList) && ObjectLength(veritracks.enrollees.mapping.data.LookAheadCardList) > 0) {
            lLookAheadData = veritracks.enrollees.mapping.NextDayData(aEnrolleeId, aStartTime, aEndTime);
        }

        lPreference = lPreferences['TrackType'];
        if (!isNullOrUndefined(lPreference)) {
            lValue = parseInt(lPreference.Value, 10);
        }

        if (lValue === 1 && mStateManager.Settings()[0] !== 'Victims') {
            if (!isNullOrUndefined(lLookAheadData)) {
                visit_OnComplete(null, lLookAheadData.Data);
            } else {
                visit_Init();
            }
        } else {
            if (!isNullOrUndefined(lLookAheadData)) {
                trackpoint_OnComplete(null, lLookAheadData.Data);
            } else {
                trackpoint_Init();
            }
        }
        if (lEnrollee.EnrolleeType == 1) {
            //address_Init();
            zone_Init();
            veritracks.mapping.getAlchoholTestCardItems(aEnrolleeId, aEnrolleePosition, aStartTime, aEndTime, alcoholTest_OnInitialized, alcohol_OnFailure);
        }

        lPreference = lPreferences['IsCaseLoadVisible'];
        if (!isNullOrUndefined(lPreference)) {
            CardViewLocation_Init();
        }
        if ($('#ie').hasClass('ie8')) {
            $('#uEnrolleesMapButtonContentOverheadBar').hide();
        }
    }

    setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', true, begin);
    $('#uEnrolleesNoData').hide();
    $('.MapFilter').hide();
    veritracks.enrollees.mapping.data.EnrolleesLoading += 1;
    veritracks.enrollees.mapping.data.DisplayVisitCount = false;
    veritracks.enrollees.mapping.data.VisitCardList = [];

    if (!mEnrolleesData.AgentTimeManagement[mEnrolleesData.OffenderCurrentId] || mEnrolleesData.AgentTimeManagement[mEnrolleesData.OffenderCurrentId].finished) {
        mEnrolleesData.AgentTimeManagement[mEnrolleesData.OffenderCurrentId] = new VeritracksAgentOffenderMapTimeManagement(mEnrolleesData.OffenderCurrentId);
    }
};



veritracks.enrollees.mapping.clear = function (aEnrolleePosition) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    if (isNullOrUndefined(aEnrolleePosition) || aEnrolleePosition === 1) {
        veritracks.enrollees.mapping.data.PrimaryCardList = [];
    } else {
        if (mStateManager.Settings()[0] === 'Offenders') {
            lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderSecondaryCurrentId, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
            veritracks.enrollees.mapping.data.LookAheadCardList = query(veritracks.enrollees.mapping.data.LookAheadCardList, lBuilder.RootExpression);
            veritracks.enrollees.mapping.data.VisitCardList = query(veritracks.enrollees.mapping.data.VisitCardList, lBuilder.RootExpression);

        } else {
            lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.VictimSecondaryCurrentId, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
            veritracks.enrollees.mapping.data.LookAheadCardList = query(veritracks.enrollees.mapping.data.LookAheadCardList, lBuilder.RootExpression);
            veritracks.enrollees.mapping.data.VisitCardList = [];
        }
    }
    if (mStateManager.Settings()[0] === 'Offenders') {
        mEnrolleesData.OffenderSecondaryCurrentId = null;
        veritracks.enrollees.mapping.data.SecondaryCardList = [];
        mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
    } else {
        mEnrolleesData.VictimSecondaryCurrentId = null;
        veritracks.enrollees.mapping.data.SecondaryCardList = [];
        mEnrolleesControls.VictimTrackpointDetailCardViewFilter.filter();
    }
};

veritracks.enrollees.mapping.tagDataUpdated = function () {
    "use strict";
    var lTagList = getDataItems('Tag'),
        lCardList = [],
        lCard,
        lItem,
        lKey;

    for (lKey in lTagList) {
        if (lTagList.hasOwnProperty(lKey)) {
            lItem = lTagList[lKey];
            lCard = veritracks.enrollees.mapping.generateTagCard(lItem);
            lCardList[lItem.Id] = lCard;
        }
    }
    veritracks.enrollees.mapping.data.TagCardList = lCardList;
};

veritracks.enrollees.mapping.filter = function (aSender, aExpression, aParams) {
    "use strict";
    var lCardList = [],
        lCardList2 = [],
        lCardDisplay = [],
        lSort = new SortExpression(),
        lLabelList = [],
        lTagList = [],
        lTagLabelList = [],
        lAddressList = [],
        lZoneList = [],
        lAlcoholList = [],
        lPrimaryTrackpointList = [],
        lMarkerList = [],
        lMarkerCardList = [],
        lSecondaryTrackpointList = [],
        lDisplayConnectedTracks = true,
        lDisplayLabel = true,
        lTrackPointCount = 0,
        lExpandedTrackPointCount = 0,
        lVisitCount = 0,
        lCardCount = 0,
        lEnrollee = mEnrolleesData.OffenderCurrentId !== -1 ? getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees') : getDataItem(mEnrolleesData.VictimCurrentId, 'Enrollees'),
        lSecondaryEnrollee,
        lMapBounds,
        lTrackItem,
        lPreferences = getUserPreferences(4),
        lPreference,
        lTrackTypeValue,
        lTrackpointCountDetail,
        lItem,
        lValue = mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type'),
        lKey,
        lPreview = gUserPermissions[61],
        lFixedMarkerElement,
        lTrackpointEventsFilter = true,
        lVisitAssociationsFilter = true,
        lIsInformatics = false,
        lFREQUENT_VISIT_ID=801,
        lFrequentVisitList =[];
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
       
    if (!$('#uShowTrackPointEventsButton').hasClass('Selected')) {
        lTrackpointEventsFilter = false;
    }
    if (mStateManager.Hash().Settings[0] === 'Offenders')
        mEnrolleesData.VictimCurrentId = -1;
    if (mEnrolleesData.VictimCurrentId !== -1) {
        Victim.mapping_filter(aSender, aExpression, aParams);
    }
    else {
        if (isNullOrUndefined(lEnrollee)) {
            lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'EnrolleesUniversal');
        }

        if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
            lSecondaryEnrollee = getDataItem(mEnrolleesData.OffenderSecondaryCurrentId, 'Enrollees');

            if (isNullOrUndefined(lSecondaryEnrollee)) {
                lSecondaryEnrollee = getDataItem(mEnrolleesData.OffenderSecondaryCurrentId, 'EnrolleesUniversal');
            }
        }
        if (!isNullOrUndefined(aExpression)) {
            if (aExpression.__type === 'ExpressionConditional:www.sumosoftware.com/Expressions') {
                lDisplayLabel = (aExpression.Name === 'Type' && aExpression.Value.indexOf('10') !== -1);
                lDisplayConnectedTracks = (aExpression.Name === 'Type' && aExpression.Value.indexOf('7') !== -1);
                lTrackpointEventsFilter = (aExpression.Name === 'Type' && aExpression.Value.indexOf('20') !== -1);
                lVisitAssociationsFilter = (aExpression.Name === 'Type' && aExpression.Value.indexOf('99') !== -1);
                if((aExpression.Name === 'Type' && aExpression.Value.indexOf('3') !== -1)){
                    lVisitAssociationsFilter = true;
                }
            } else if (aExpression.__type === 'ExpressionBinary:www.sumosoftware.com/Expressions') {
                lDisplayLabel = (aExpression.LeftOperand.Name === 'Type' && aExpression.LeftOperand.Value.indexOf('10') !== -1) || (aExpression.RightOperand.Name === 'Type' && aExpression.RightOperand.Value.indexOf('10') !== -1);
                lDisplayConnectedTracks = (aExpression.LeftOperand.Name === 'Type' && aExpression.LeftOperand.Value.indexOf('7') !== -1) || (aExpression.RightOperand.Name === 'Type' && aExpression.RightOperand.Value.indexOf('7') !== -1);
                lTrackpointEventsFilter = (aExpression.LeftOperand.Name === 'Type' && aExpression.LeftOperand.Value.indexOf('20') !== -1) || (aExpression.RightOperand.Name === 'Type' && aExpression.RightOperand.Value.indexOf('20') !== -1);
                lVisitAssociationsFilter = (aExpression.LeftOperand.Name === 'Type' && aExpression.LeftOperand.Value.indexOf('99') !== -1) || (aExpression.RightOperand.Name === 'Type' && aExpression.RightOperand.Value.indexOf('99') !== -1);
                if((aExpression.LeftOperand.Name === 'Type' && aExpression.LeftOperand.Value.indexOf('3') !== -1) || (aExpression.RightOperand.Name === 'Type' && aExpression.RightOperand.Value.indexOf('3') !== -1)){
                    lVisitAssociationsFilter = true;
                }
            }

        } 
        lCardList = veritracks.enrollees.mapping.data.PrimaryCardList;
        if (mEnrolleesData.OffenderCurrentId !== mEnrolleesData.OffenderSecondaryCurrentId && !isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
            lCardList = lCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList);
        }
        else {
            veritracks.enrollees.mapping.data.SecondaryCardList = [];
        }
        lCardList = lCardList.concat(veritracks.enrollees.mapping.data.VisitCardList);
        //lCardList = lCardList.concat(veritracks.enrollees.mapping.data.TagCardList);

        lCardList = query(lCardList, aExpression);
        lSort.addAscendingColumn('SortOrder');
        lSort.addDescendingColumn('SortDate');
        lSort.addAscendingColumn('Type');
        lCardList = lSort.sort(lCardList);
        

        // place Addresses and zones at the bottom
        lCardList = veritracks.enrollees.mapping.FixCardSortOrder(lCardList);
        lTrackpointEventsFilter = lIsInformatics == true ? !lTrackpointEventsFilter : lTrackpointEventsFilter;
        if (!lTrackpointEventsFilter || !lEnrollee.InMyOrganization) {
            lCardList = veritracks.enrollees.mapping.TrackpointEventsFilter(lCardList);
        }
        lCardCount = veritracks.enrollees.mapping.TrackPointDetailCardViewCounter(lCardList);        
        if(!isNullOrUndefined(aExpression.LeftOperand) && aExpression.LeftOperand.Value.includes('2')){
            mEnrolleesControls.EnrolleesMap.layerShow('PointOfInterestShape');
        }else { 
            mEnrolleesControls.EnrolleesMap.layerHide('PointOfInterestShape');
        }
        for (lKey in lCardList) {
            if (lCardList.hasOwnProperty(lKey)) {
                lItem = $.extend({}, lCardList[lKey]);
                lItem.DisplayName = lItem.Name + ' (' + veritracks.enrollees.mapping.CardParsedName(lItem) + veritracks.enrollees.mapping.CountFixer(lCardCount, lItem).toString() + ')';
                lCardDisplay.push(lItem);
                lTrackItem = lItem.TrackItem;
                switch (lItem.SortOrder) {
                    case 0:
                        lTagList.push(lTrackItem);
                        lTagLabelList.push(lTrackItem.data);
                        break;
                    case 1:
                        lAddressList.push(lTrackItem);
                        if (lDisplayLabel) {
                            lLabelList.push(lItem);
                        }
                        break;
                    case 2:
                        lZoneList.push(lTrackItem);
                        break;
                    case 3:
                        switch (lItem.Type) {
                            case 4:
                                if (lItem.TrackItem.data.TrackTypeId == 1) {
                                    ++lExpandedTrackPointCount;
                                }
                                break;
                            case 5:
                                if (lItem.TrackItem.data.TrackTypeId == 1) {
                                    ++lTrackPointCount;
                                }
                                break;
                        }
                        if (lItem.EnrolleeId === mEnrolleesData.OffenderCurrentId) {
                            lTrackItem.data.TimeZoneId = lEnrollee.TimeZoneId;
                            lTrackItem.data.Count = veritracks.enrollees.mapping.CountFixer(lCardCount, lItem);
                            if (lIsInformatics) {
                                lTrackItem.TrackItem = { 'index': lTrackItem.index, 'SVGMarker': lTrackItem.SVGMarker, 'degreeRotation': lTrackItem.degreeRotation, 'centerX': lTrackItem.centerX, 'centerY': lTrackItem.centerY };
                                if(lTrackItem.data.IconId==lFREQUENT_VISIT_ID){
                                    lFrequentVisitList.push(lTrackItem.data);
                                }
                            }
                            lPrimaryTrackpointList.push(lTrackItem);
                        } else {
                            if (lSecondaryEnrollee) {
                                lTrackItem.data.TimeZoneId = lSecondaryEnrollee.TimeZoneId;
                                lTrackItem.data.Count = veritracks.enrollees.mapping.CountFixer(lCardCount, lItem);
                                lSecondaryTrackpointList.push(lTrackItem);
                            }
                        }
                        if (lDisplayLabel) {
                            lLabelList.push(lItem);
                        }

                        break;
                    case 4:
                        lAlcoholList.push(lTrackItem);
                        break;
                }
                lCardCount = veritracks.enrollees.mapping.CountKeeper(lItem, lCardCount);
            }
        }
       
        if (lIsInformatics) {
            for (lKey in veritracks.mapping.data.EnumeratedIcons) {
                if (veritracks.mapping.data.EnumeratedIcons.hasOwnProperty(lKey)) {
                    lFixedMarkerElement = $.extend({}, mEnrolleesIcon.icons[0]);
                    if (isNullOrUndefined(veritracks.mapping.data.EnumeratedIcons[lKey].FileMarker) || veritracks.mapping.data.EnumeratedIcons[lKey].FileMarker) {
                        lFixedMarkerElement.IconName = lKey;
                        lFixedMarkerElement.IconValue = veritracks.mapping.iconGenerator.cleanSVGTag(veritracks.mapping.data.EnumeratedIcons[lKey].SVGMarker, true);
                        lFixedMarkerElement.Id = -1;
                        lFixedMarkerElement.DegreeRotation = veritracks.mapping.data.EnumeratedIcons[lKey].BearingDegree
                        lFixedMarkerElement.CenterX = veritracks.mapping.data.EnumeratedIcons[lKey].CenterX;
                        lFixedMarkerElement.CenterY = veritracks.mapping.data.EnumeratedIcons[lKey].CenterY;
                        lMarkerList.push(lFixedMarkerElement);
                    }                   
                }
            }
        }              
        GenerateIconsPng(lMarkerList, function () {
            lPrimaryTrackpointList.reverse();
            lTagLabelList = veritracks.mapping.prepareSuggestionLabelOverlayData(lTagLabelList);
            mEnrolleesControls.OffenderTrackpointDetailCardView.setDataSource(lCardDisplay);
            lMapBounds = mEnrolleesControls.EnrolleesMap.getBoundsFromArray(lPrimaryTrackpointList);
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('Tags', lTagList);
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('TagLabels', lTagLabelList);
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('Addresses', lAddressList);
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('Zones', lZoneList);
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('ZonesNames', veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(lZoneList));
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('Visits', lPrimaryTrackpointList);
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryVisits', lSecondaryTrackpointList);
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('AlchoholTestPoints', lAlcoholList);
            if (lDisplayConnectedTracks) {
                mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedTracks', veritracks.mapping.prepareTripPointLineSegmentData(lPrimaryTrackpointList));
                mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryConnectedTracks', veritracks.mapping.prepareTripPointLineSegmentData(lSecondaryTrackpointList));
            } else {
                mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedTracks', []);
                mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryConnectedTracks', []);
            }
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('Labels', veritracks.mapping.prepareTrackpointDetailCardLabelOverlayData(lLabelList, lValue));

            if (lCardDisplay.length > 0) {
                var HasPreviousZoom = veritracks.enrollees.mapping.data.PreviousZoom > 0;
                if (veritracks.enrollees.mapping.data.DoFitBounds && !HasPreviousZoom) {
                    if (!lMapBounds.isEmpty()) {
                        mEnrolleesControls.EnrolleesMap.fitBounds(lMapBounds);
                    } else {
                        mEnrolleesControls.EnrolleesMap.fitBounds();
                    }
                }
                //mEnrolleesControls.EnrolleesMap.zoom(
                $('#uEnrolleesNoData').hide();
                $('#uEnrolleesNoDataText').empty();
            } else {
                if (veritracks.enrollees.mapping.data.PrimaryCardList.length > 0 || veritracks.enrollees.mapping.data.SecondaryCardList.length > 0) {
                    $('#uEnrolleesNoDataText').text(localizeText('cEnrolleeNoTrackDataFilter'));
                } else {
                    $('#uEnrolleesNoDataText').text(localizeText('cEnrolleeNoTrackData'));
                }
                $('#uEnrolleesNoData').show();
                uTrackpointDetailCardView_OnSelectChange(mEnrolleesControls.OffenderTrackpointDetailCardView, null, null);
                //mEnrolleesControls.OffenderTrackpointDetailCardView.selected(-1);
            }
            veritracks.enrollees.mapping.data.DoFitBounds = true;

            lPreference = lPreferences['TrackType'];

            if (!isNullOrUndefined(lPreference)) {
                lTrackTypeValue = parseInt(lPreference.Value, 10);
            }
            var lCount = 0;
            // if (lVisitCount > 0) {
            lVisitCount = CalculateVisitCount();
            lCount = CalculateVisitTrackPointCount(false)
            //  }
            var lTrackPointCount = CalculateTrackpointCount();
            lCount += lTrackPointCount;
            mEnrolleesData.GpsCount = lCount;
            if (isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
                lTrackpointCountDetail = lEnrollee.FullName;
            }
            else {
                lTrackpointCountDetail = localizeText('cEnrolleeTotal');
            }
            lTrackpointCountDetail += ': ' + lCount.toString() + ' ' + localizeText('cEnrolleeGPSPoints');
            if (lVisitCount.Count == 1 && lTrackPointCount == 0 && lVisitCount.InProgress) {
                lTrackpointCountDetail += ' (' + localizeText('cEnrolleeCurrentVisit') + ')';
            }
            if (lTrackTypeValue === 1 && veritracks.enrollees.mapping.data.DisplayVisitCount) {
                lTrackpointCountDetail += ', ' + lVisitCount.Count + ' ' + localizeText('cEnrolleeVisit');
                if (lVisitCount !== 0) {
                    lTrackpointCountDetail += 's';
                }
            }

            $('#uEnrolleeTrackPointCount').html(lTrackpointCountDetail).show();

            if (lValue.indexOf('3') === -1) {
                $('#uShowVisitsButton').removeClass('Selected');
            } else {
                $('#uShowVisitsButton').addClass('Selected');
            }
            if (lValue.indexOf('4') === -1) {
                $('#uShowVisitPointsButton').removeClass('Selected');
            } else {
                $('#uShowVisitPointsButton').addClass('Selected');
            }
            if (lValue.indexOf('5') === -1) {
                $('#uShowTrackpointsButton').removeClass('Selected');
            } else {
                $('#uShowTrackpointsButton').addClass('Selected');
            }
            if (lEnrollee.InMyOrganization) {
                if (lValue.indexOf('20') === -1) {
                    $('#uShowTrackPointEventsButton').removeClass('Selected');
                } else {
                    $('#uShowTrackPointEventsButton').addClass('Selected');
                }
            } else{
                $('#uShowTrackPointEventsButton').hide();
            }

            $(window).resize();
            TimelineRemoveLeftoverPopup();
            writeUserPreferences(aSender.FilterState);
            $('#uMapPlaybackPanel').show();

            if (aSender.Id == "uTrackpointDetailCardViewFilter") {
                var ltrackallCount = CalculateAllPlaybackTracksPoints();
                if (ltrackallCount > 0) {
                    mEnrolleesControls.PlaybackControl.Activate(true);
                     
                    uEnrolleesMapPlaybackLock();
                } else {
                    mEnrolleesControls.PlaybackControl.Activate(false);
                    uEnrolleesMapPlaybackLock();
                }
            }
            var lClientProperty = veritracks.system.clientSetting('TrackReviewByPlayback');
            if (lClientProperty) {
                // can view toggle 
                var lDateRange = offenderMapPopulate_GetDateRange();
                var lOffenderEvents = EnrolleeHelper.getEventsByRangeDate(mEnrolleesData.OffenderCurrentId, lDateRange.startDate, lDateRange.endDate);
                mEnrolleesControls.PlaybackControl.setDataBookmarks('Events',lOffenderEvents);
                mEnrolleesControls.PlaybackControl.setDataBookmarks('FrequentVisits',lFrequentVisitList);
                enrolleeBookmarksToggleButton_OnClick();//TODO: replace
                $('#uBookmarksToggleButtonContent').show();
            } else {
                $('#uBookmarksToggleButtonContent').hide();
            }
            
            veritracks.localization.localizeTitle('#uTrackpointDetailCardViewHolder');
        }, veritracks.enrollees.mapping.IconsGenerateOnFail, null, !lIsInformatics);
       
    }
    
    if (!isNullOrUndefined(lPreview) && lPreview.Value == 1) {
        $('#uShowHeatMapButton').show();
    } else {
        $('#uShowHeatMapButton').hide();
    }

    if (!isNullOrUndefined(mEnrolleesControls.EnrolleesMap.getHeatMap())) {
        mEnrolleesControls.EnrolleesMap.disposeHeatMap();
        uShowHeatMapButton_OnClick();
    } 
};

veritracks.enrollees.mapping.TrackPointDetailCardViewCounter = function (aCardList) {
    "use strict";
    var lCardList = aCardList,
        lType,
        lKey,
        lCounter = [8];

    for (lKey in lCardList) {
        if (lCardList.hasOwnProperty(lKey)) {
            lType = lCardList[lKey].Type;
            if (lType == 4 || lType == 5 || lType == 8) {
                if (lCardList[lKey].TrackItem.data.TrackTypeId == 3 || lCardList[lKey].TrackItem.data.TrackTypeId == 2) {
                    if (isNaN(lCounter[4])) {
                        lCounter[4] = 0;
                    }
                    lCounter[4]++;
                }
                else {
                    if (isNaN(lCounter[5])) {
                        lCounter[5] = 0;
                    }
                    lCounter[5]++;
                }
            }
            else {
                lCounter[lType] = 1;
            }
        }
    }

    return lCounter;
}

veritracks.enrollees.mapping.CountFixer = function (aCount, aCard) {
    "use strict";
    var lType = aCard.Type,
        lCount = aCount[lType];

    if ((!isNullOrUndefined(aCard.TrackItem.data.TrackTypeId) && aCard.TrackItem.data.TrackTypeId == 1)) {
        lCount = aCount[5];
    }
    else if ((!isNullOrUndefined(aCard.TrackItem.data.TrackTypeId) && aCard.TrackItem.data.TrackTypeId == 2 || aCard.TrackItem.data.TrackTypeId == 3)) {
        lCount = aCount[4];
    }

    return lCount;
}

veritracks.enrollees.mapping.CountKeeper = function (aCard, aCounter) {
    var lType = aCard.Type;

    if (!isNullOrUndefined(aCard.TrackItem.data.TrackTypeId) && aCard.TrackItem.data.TrackTypeId == 1) {
        aCounter[5]--;
    }
    else if (!isNullOrUndefined(aCard.TrackItem.data.TrackTypeId) && aCard.TrackItem.data.TrackTypeId == 2 || aCard.TrackItem.data.TrackTypeId == 3) {
        aCounter[4]--;
    }
    else {
        aCounter[lType]++;
    }
    return aCounter;
}

veritracks.enrollees.mapping.CardParsedName = function (aCard) {
    "use strict";
    var lType = aCard.Type,
        lParsed = '';
    if (lType == 1) {
    }
    else if (lType == 3) {
        lParsed = 'V';
    }
    else if (!isNullOrUndefined(aCard.TrackItem.data.TrackTypeId)) {
        if (aCard.TrackItem.data.TrackTypeId == 3 || aCard.TrackItem.data.TrackTypeId == 2 && lType == 8) {
            lParsed = 'CTP';
        }
        else {
            lParsed = 'TP';
        }
    }
    return lParsed;
}


veritracks.enrollees.mapping.FixCardSortOrder = function (mCardList) {
    "use strict"
    var lCardList = mCardList,
        lTemp = [],
        i = 0;

    for (i = 0; i < ObjectLength(lCardList) ; i++) {
        if (lCardList.hasOwnProperty(i)) {
            if (lCardList[i].Type == 1 || lCardList[i].Type == 2) {
                lTemp.push(lCardList[i]);
                lCardList.splice(i, 1);
                i--;
            }
        }
    }
    lCardList = lCardList.concat(lTemp);
    return lCardList;
};

veritracks.enrollees.mapping.VisitAssociationsFilter = function (mCardList) {
    "use strict";
    var lKey,
    lCardList = [],
    lTemp;

    // remove event icons from trackpoints
    for (lKey in mCardList) {
        if (mCardList.hasOwnProperty(lKey)) {
            // trackpoints and visitpoints
            var lEventsOcurred = false;
            var lIsXTrackPoint = false;
            if (mCardList[lKey].IconClass == "Track11100100" || mCardList[lKey].IconClass == "Track11101001" || mCardList[lKey].IconClass == "Track11100001")
                lIsXTrackPoint = true;

            if (mCardList[lKey].TrackItem.data.IsInBraceletStrap) {
                lEventsOcurred = true;
            }
            if (mCardList[lKey].TrackItem.data.IsInExclusionZone) {
                lEventsOcurred = true;
            }
            if (mCardList[lKey].TrackItem.data.IsInInclusionZone) {
                lEventsOcurred = true;
            }
            if (mCardList[lKey].TrackItem.data.IsInLowBattery) {
                lEventsOcurred = true;
            }
            if (mCardList[lKey].TrackItem.data.IsOnCharger) {
                lEventsOcurred = true;
            }
            if (!lIsXTrackPoint && lEventsOcurred && (mCardList[lKey].Type == '5' || mCardList[lKey].Type == '4') && mCardList[lKey].TrackItem.data.TrackTypeId !== 3 && (mCardList[lKey].Type !== 8 && mCardList[lKey].TrackItem.data.TrackTypeId !== 2)) {
                lCardList.push(JSON.parse(JSON.stringify(mCardList[lKey])));
                // preserve dates
                lCardList[lKey].TrackItem.data.TrackDate = mCardList[lKey].TrackItem.data.TrackDate;
                lCardList[lKey].Date = mCardList[lKey].Date;
                lCardList[lKey].EndDate = mCardList[lKey].EndDate;

                if (lCardList[lKey].IconClass.indexOf('Track2') !== -1) {
                    lCardList[lKey].IconClass = 'Track20100000';
                    lCardList[lKey].TrackItem.cardViewClass = 20100000;
                    lCardList[lKey].TrackItem.iconUri = "Images/Maps/Trackpoints/20100000.png";
                }
                else {
                    lCardList[lKey].IconClass = 'Track10100000';
                    lCardList[lKey].TrackItem.cardViewClass = 10100000;
                    lCardList[lKey].TrackItem.iconUri = "Images/Maps/Trackpoints/10100000.png";
                }
            }

            else {
                lCardList.push(mCardList[lKey]);
            }
        }
    }

    return lCardList;
}

veritracks.enrollees.mapping.TrackpointEventsFilter = function (mCardList) {
    "use strict";
    var lKey,
        lCardList = [],
        lIconNameList = [],
        lMarkerList = [],
        lFixedMarkerElement,
        lTrackItem,
        lSVGMarker,
        lIndex,
        lPreviousIcon,
        lEventNameIndex,
        lMarker,
        lEnrollee =  getDataItem(mEnrolleesData.OffenderCurrentId !== -1 ?mEnrolleesData.OffenderCurrentId : mEnrolleesData.VictimCurrentId, 'Enrollees'),
        lIsInformatics = false;

    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }        

    // remove event icons from trackpoints
    for (lKey in mCardList) {
       if (mCardList.hasOwnProperty(lKey)) {
           // trackpoints and visitpoints
           var lEventsOcurred = false;
           var lIsXTrackPoint = false;
           if (mCardList[lKey].IconClass == "Track11100100" || mCardList[lKey].IconClass == "Track11101001" || mCardList[lKey].IconClass == "Track11100001")
               lIsXTrackPoint = true;

           if (mCardList[lKey].TrackItem.data.IsInBraceletStrap) {
               lEventsOcurred = true;
           }
           if (mCardList[lKey].TrackItem.data.IsInExclusionZone) {
               lEventsOcurred = true;
           }
           if (mCardList[lKey].TrackItem.data.IsInInclusionZone) {
               lEventsOcurred = true;
           }
           if (mCardList[lKey].TrackItem.data.IsInLowBattery) {
               lEventsOcurred = true;
           }
           if (mCardList[lKey].TrackItem.data.IsOnCharger) {
               lEventsOcurred = true;
           }
           if (!lIsXTrackPoint && lEventsOcurred && (mCardList[lKey].Type == '5' || mCardList[lKey].Type == '4') && mCardList[lKey].TrackItem.data.TrackTypeId !== 3 && (mCardList[lKey].Type !== 8 && mCardList[lKey].TrackItem.data.TrackTypeId !== 2)) {
               lCardList.push(JSON.parse(JSON.stringify(mCardList[lKey])));               
               // preserve dates
               lCardList[lKey].TrackItem.data.TrackDate = mCardList[lKey].TrackItem.data.TrackDate;
               lCardList[lKey].Date = mCardList[lKey].Date;
               lCardList[lKey].EndDate = mCardList[lKey].EndDate;

               if (lIsInformatics == false) {
                   if (lCardList[lKey].IconClass.indexOf('Track2') !== -1) {
                       lCardList[lKey].IconClass = 'Track20100000';
                       lCardList[lKey].TrackItem.cardViewClass = 20100000;
                       lCardList[lKey].TrackItem.iconUri = "Images/Maps/Trackpoints/20100000.png";
                   }
                   else {
                       lCardList[lKey].IconClass = 'Track10100000';
                       lCardList[lKey].TrackItem.cardViewClass = 10100000;
                       lCardList[lKey].TrackItem.iconUri = "Images/Maps/Trackpoints/10100000.png";
                   }
               } else {                   
                   lIndex = veritracks.mapping.generateEventIconNames(lCardList[lKey].TrackItem.data,lCardList[lKey].EnrolleePosition);
                   if (typeof veritracks.mapping.data.EnumeratedIcons[lIndex] == 'undefined') {                       
                       lTrackItem = lCardList[lKey].TrackItem;
                       //console.log(lTrackItem)
                       lPreviousIcon = mEnrolleesIcon.icons[lTrackItem.data.IconId];
                       veritracks.mapping.iconGenerator.addSVGToQueue({ "IconValue": lTrackItem.SVGMarker, "Width": lPreviousIcon.Width, "Height": lPreviousIcon.Height});
                       

                       if (lCardList[lKey].TrackItem.data.IsInBraceletStrap && !isNullOrUndefined(lCardList[lKey].TrackItem.data.IconId)) {
                           //master tamper icon
                           veritracks.mapping.iconGenerator.addSVGToQueue(mEnrolleesIcon.icons[IconHelper.getIconIdByName("Master Tamper")]);
                       }//strap 

                       if (lCardList[lKey].TrackItem.data.IsInExclusionZone && !isNullOrUndefined(lCardList[lKey].TrackItem.data.IconId)) {
                           //exclusion icon
                           veritracks.mapping.iconGenerator.addSVGToQueue(mEnrolleesIcon.icons[IconHelper.getIconIdByName("Exclusion")]);
                       }//exclusion

                       if (lCardList[lKey].TrackItem.data.IsInInclusionZone && !isNullOrUndefined(lCardList[lKey].TrackItem.data.IconId)) {
                           //inclusion icon
                           veritracks.mapping.iconGenerator.addSVGToQueue(mEnrolleesIcon.icons[IconHelper.getIconIdByName("Inclusion")]);
                       }//inclusion

                       if (lCardList[lKey].TrackItem.data.IsOnCharger && !isNullOrUndefined(lCardList[lKey].TrackItem.data.IconId)) {
                           //charger icon
                           veritracks.mapping.iconGenerator.addSVGToQueue(mEnrolleesIcon.icons[IconHelper.getIconIdByName("On Charger")]);
                       }//inclusion

                       if (lCardList[lKey].TrackItem.data.IsInLowBattery && !isNullOrUndefined(lCardList[lKey].TrackItem.data.IconId)) {
                           //low battery icon
                           veritracks.mapping.iconGenerator.addSVGToQueue(mEnrolleesIcon.icons[IconHelper.getIconIdByName("Low Battery")]);
                       }//inclusion                       

                       if (veritracks.mapping.iconGenerator.drawSVG()) {
                           //get generated svg
                           var mSvgMarker = veritracks.mapping.iconGenerator.getSvg();
                           //lMarker = veritracks.mapping.iconGenerator.generateMapMarker(mSvgMarker);
                           lCardList[lKey].TrackItem.iconUri = VERITRACKS_WEB_LOCAL + veritracks.system.clientSetting("svgimagespath") + lIndex + ".png";
                           lCardList[lKey].TrackItem.SVGMarker = mSvgMarker;
                           //update card icon
                           lCardList[lKey].iconUri = VERITRACKS_WEB_LOCAL + veritracks.system.clientSetting("svgimagespath") + lIndex + ".png";
                           veritracks.mapping.data.EnumeratedIcons[lIndex] = { 'SVGMarker': mSvgMarker, 'BearingDegree': lTrackItem.BearingDegree, 'CenterX': lTrackItem.CenterX, 'CenterY': lTrackItem.CenterY };;
                       }
                       veritracks.mapping.iconGenerator.clear();
                   } else {
                       lTrackItem = veritracks.mapping.prepareRawSvg(lCardList[lKey].TrackItem.data, true);
                       var lbindMarkers = lTrackItem.BindMarkers;
                       var lLabel = lTrackItem.VisitLabels;
                       if (lLabel != null) {
                           veritracks.mapping.iconGenerator.addText(lLabel, {
                               family: 'Helvetica',
                               size: 5,
                               anchor: 'middle',
                               leading: '1.5em'
                           });
                       }
                       //get generated svg
                       var mSvgMarker = veritracks.mapping.data.EnumeratedIcons[lIndex];
                       //lMarker = veritracks.mapping.iconGenerator.generateMapMarker(mSvgMarker.SVGMarker);
                       lCardList[lKey].TrackItem.iconUri = VERITRACKS_WEB_LOCAL + veritracks.system.clientSetting("svgimagespath") + lIndex + ".png";
                       lCardList[lKey].TrackItem.SVGMarker = mSvgMarker.SVGMarker;
                       //update card icon
                       lCardList[lKey].iconUri = VERITRACKS_WEB_LOCAL + veritracks.system.clientSetting("svgimagespath") + lIndex + ".png";
                      
                   }
               }              
               
           } else {               
               lCardList.push(mCardList[lKey]);
           }
           
           //if (!isNullOrUndefined(lIndex)) {
           //    lCardList[lKey].TrackItem.index = lIndex + ".png";
           //}
          
       }
    }  
  
   return lCardList;
}

veritracks.enrollees.mapping.IconsGenerateOnSuccess = function(aParams, aData, c){
    console.log(aParams);
    console.log(aData);
    console.log(c);
}

veritracks.enrollees.mapping.IconsGenerateOnFail = function(aParams, aData, c){
    console.log(aParams);
    console.log(aData);
    console.log(c);
}

veritracks.enrollees.mapping.zoomOut = function (mMap, ZoomLevel) {
    if (!isNullOrUndefined(mMap)) {
        if (!isNaN(ZoomLevel)) {
            var maxZoomService = new google.maps.MaxZoomService();
            maxZoomService.getMaxZoomAtLatLng(mMap.getCenter(), function (response) {
                var zoom;
                if (response.status != google.maps.MaxZoomStatus.OK) {
                    switch (mMap.mapTypeId) {

                        case 'hybrid': {
                            zoom = mMap.mapTypes.hybrid.maxZoom;
                            break;
                        }
                        case 'roadmap': {
                            zoom = mMap.mapTypes.roadmap.maxZoom;
                            break;
                        }
                        case 'satellite': {
                            zoom = mMap.mapTypes.satellite.maxZoom;
                            break;
                        }
                        case 'terrain': {
                            zoom = mMap.mapTypes.terrain.maxZoom;
                            break;
                        }
                    }
                    zoom = zoom - ZoomLevel;

                }
                else {
                    zoom = response.zoom - ZoomLevel;
                }
                if (veritracks.enrollees.mapping.data.CurrentCardType == 2) {
                    mMap.setZoom(zoom - ZoomLevel);
                } else {
                    mMap.setZoom(zoom);
                }

            });

        }
    }
};
veritracks.enrollees.mapping.collapseVisits = function (aDoRender, aIsRefreshed) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList),
        lItem,
        lKey,
        mSelected = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem(),
        mRefreshed = false;


    if (!isNullOrUndefined(aIsRefreshed)) {
        mRefreshed = aIsRefreshed;
    }
    if (aDoRender) {
        mRefreshed = aDoRender;
    }
    lBuilder.AddNewExpressionConditional('IsExpanded', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    if (!isNullOrUndefined(mSelected)) {
        lBuilder.AddNewExpressionConditional('VisitId', mSelected.VisitId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    }
    lData = query(lData, lBuilder.RootExpression);
    for (lKey in lData) {
        if (lData.hasOwnProperty(lKey)) {
            lItem = lData[lKey];
            lItem.IsExpanded = false;
        }
    }

    // Erase item from past data, use this to keep state on refresh
    if (mRefreshed) {
        if (!isNullOrUndefined(mEnrolleesData.OffenderPastData) && !isNullOrUndefined(lItem)) {
            for (lKey in mEnrolleesData.OffenderPastData) {
                if (mEnrolleesData.OffenderPastData.hasOwnProperty(lKey)) {
                    if (mEnrolleesData.OffenderPastData[lKey].Id == lItem.Id) {
                        mEnrolleesData.OffenderPastData.splice(lKey, 1);
                    }
                }
            }
        }
    }
    veritracks.enrollees.mapping.data.VisitCardList = [];
    function onSuccess(aParams, aData) {
        veritracks.enrollees.mapping.RemoveFromTotalVisitCardList(aData);

        if (aDoRender) {
            veritracks.enrollees.mapping.data.DoFitBounds = false;
            if (ObjectLength(mEnrolleesData.OffenderPastData)) {
                mEnrolleesData.VisitsProcesssed = false;
            }
            mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
        }
    }

    function begin() {
        veritracks.mapping.visitExpandTrackpoints(mSelected, offenderMapPopulate_GetDateRange(), onSuccess);
    }
    if (lData.length > 0 && !isNullOrUndefined(mEnrolleesData.OffenderPastData) && mRefreshed) {
        setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false, begin);
    }
    //else {
    //    veritracks.enrollees.mapping.data.VisitCardList = [];
    //}
};

veritracks.enrollees.mapping.expandVisit = function (aMapCard) {
    "use strict";
    var mBuilder = new SumoPredicateBuilder(),
       mData,
       mCard,
       mEnrolleePosition,
       mCardItem,
       mRefreshed = false;

    if (!isNullOrUndefined(aMapCard)) {
        mCard = aMapCard;
        mEnrolleePosition = parseInt(aMapCard.EnrolleePosition);
        mRefreshed = true;
    }
    else {
        mCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
        mEnrolleePosition = parseInt(mCard.EnrolleePosition);        
    }
    function onSuccess(aData) {
        var lDoDisplayCellPoints = veritracks.system.clientSetting('MapDisplayCellCentroids'),
            lEnrollee = getDataItem(aData.EnrolleeId, 'Enrollees'),
            lSort = new SortExpression(),
            lBuilder,
            visitTrackpoints,
            lFilterValue,
            lLength,
            lCount,
            lItem,
            lCardItem,
            lCardList = [],
            lData,
            lKey;
        
        FixDates(aData.TrackItem.data.Trackpoints);
        lData = aData.TrackItem.data.Trackpoints;
        // setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false);
        if (isNullOrUndefined(lEnrollee))
            lEnrollee = getDataItem(aData.EnrolleeId, 'EnrolleesUniversal');

        if (!lDoDisplayCellPoints) {
            lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('TrackTypeId', 2, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
            visitTrackpoints = query(lData, lBuilder.RootExpression);
        }

        lSort.addDescendingColumn('TrackDate');
        visitTrackpoints = lSort.sort(visitTrackpoints);

        lLength = visitTrackpoints.length;
        for (lCount = 0; lCount < lLength; lCount++) {
            lItem = visitTrackpoints[lCount];
            lCardItem = veritracks.enrollees.mapping.generateTrackpointCard(lItem, 4, lEnrollee, mEnrolleePosition);
            lCardItem.Name = 'Visit Point ' + (lCount + 1).toString() + ' of ' + lLength.toString();
            lCardList.push(lCardItem);
        }

        //veritracks.enrollees.mapping.data.VisitCardList = lCardList;
        veritracks.enrollees.mapping.AddToTotalVisitCardList(lCardList);
        lFilterValue = mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type');
        if (!isNullOrUndefined(lFilterValue) && lFilterValue.length > 0 && lFilterValue.indexOf(4) === -1) {
            lFilterValue.push('4');
            mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type', lFilterValue)
        }
        veritracks.enrollees.mapping.data.DoFitBounds = false;
        mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
        setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false);
    }

    function begin() {
        veritracks.enrollees.mapping.collapseVisits(false, mRefreshed);

        mBuilder.Clear();
        mBuilder.AddNewExpressionConditional('Id', mCard.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList);
        mData = query(mData, mBuilder.RootExpression);

        mCardItem = mData[mData.length - 1];

        if (!isNullOrUndefined(mCardItem)) {
            mCardItem.IsExpanded = true;
            // add to OffenderPastData, use this to keep state on refresh.
            if (!isNullOrUndefined(mEnrolleesData.OffenderPastData)) {
                mEnrolleesData.OffenderPastData.push(mData);
            }
            else {
                mEnrolleesData.OffenderPastData = mData;
            }
            veritracks.enrollees.mapping.CleanOffenderPastData();
            $('#uExpandVisitButton').hide();

            onSuccess(mCardItem);
        }
        else {
            veritracks.enrollees.mapping.data.VisitCardList = [];
            mEnrolleesData.VisitsProcesssed = false;
            setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false);
            mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
        }
    }

    setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', true, begin);

}
veritracks.enrollees.mapping.expandVisitOld = function (aMapCard) {
    "use strict";
    var mBuilder = new SumoPredicateBuilder(),
        mData,
        mCard,
        mEnrolleePosition,
        mCardItem,
        mRefreshed = false;

    if (!isNullOrUndefined(aMapCard)) {
        mCard = aMapCard;
        mEnrolleePosition = parseInt(aMapCard.IconClass[5]);
        mRefreshed = true;
    }
    else {
        mCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem(),
        mEnrolleePosition = parseInt(mCard.IconClass[5]);
    }
    function onSuccess(aParams, aData) {
        var lSort = new SortExpression(),
            lBuilder,
            lCardList = [],
            lEnrollee,
            lCardItem,
            lItem,
            lCount = 0,
            lData,
            lLength,
            lDoDisplayCellPoints = veritracks.system.clientSetting('MapDisplayCellCentroids'),
            lFilterValue,
            lFilterArray,
            lKey;
        setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false);
        lEnrollee = getDataItem(aParams.EnrolleeId, 'Enrollees');
        FixDates(aData);
        lData = aData;

        if (isNullOrUndefined(lEnrollee))
            lEnrollee = getDataItem(aParams.EnrolleeId, 'EnrolleesUniversal');

        if (!lDoDisplayCellPoints) {
            lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('TrackTypeId', 2, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
            lData = query(lData, lBuilder.RootExpression);
        }

        lSort.addDescendingColumn('TrackDate');
        lData = lSort.sort(lData);

        lLength = lData.length;
        for (lCount = 0; lCount < lLength; lCount++) {
            lItem = lData[lCount];
            lCardItem = veritracks.enrollees.mapping.generateTrackpointCard(lItem, 4, lEnrollee, mEnrolleePosition);
            lCardItem.Name = 'Visit Point ' + (lCount + 1).toString() + ' of ' + lLength.toString();
            lCardList.push(lCardItem);
        }

        //veritracks.enrollees.mapping.data.VisitCardList = lCardList;
        veritracks.enrollees.mapping.AddToTotalVisitCardList(lCardList);
        lFilterValue = mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type');
        if (!isNullOrUndefined(lFilterValue) && lFilterValue.length > 0 && lFilterValue.indexOf(4) === -1) {
            lFilterValue.push('4');
            mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type', lFilterValue)
        }
        veritracks.enrollees.mapping.data.DoFitBounds = false;
        mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
    }

    function begin() {
        veritracks.enrollees.mapping.collapseVisits(false, mRefreshed);

        mBuilder.Clear();
        mBuilder.AddNewExpressionConditional('Id', mCard.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList);
        mData = query(mData, mBuilder.RootExpression);

        mCardItem = mData[mData.length - 1];

        if (!isNullOrUndefined(mCardItem)) {
            mCardItem.IsExpanded = true;
            // add to OffenderPastData, use this to keep state on refresh.
            if (!isNullOrUndefined(mEnrolleesData.OffenderPastData)) {
                mEnrolleesData.OffenderPastData.push(mData);
            }
            else {
                mEnrolleesData.OffenderPastData = mData;
            }
            veritracks.enrollees.mapping.CleanOffenderPastData();
            $('#uExpandVisitButton').hide();
            //mCard.ExpandAll = false;
            veritracks.mapping.visitExpandTrackpoints(mCard, offenderMapPopulate_GetDateRange(), onSuccess);
        }
        else {
            veritracks.enrollees.mapping.data.VisitCardList = [];
            mEnrolleesData.VisitsProcesssed = false;
            setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false);
            mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
        }
    }

    setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', true, begin);


};


veritracks.enrollees.mapping.expandAllVisits = function () {
    "use strict";
    var mBuilder = new SumoPredicateBuilder(),
        mData,
        mCardList = [];

    mEnrolleesData.VisitsProcesssed = true;
    mEnrolleesData.OffenderPastData = null;

    function prepareSingleVisit(aParams, aData) {
        var lSort = new SortExpression(),
            lBuilder,
            lCardList = [],
            lEnrollee,
            lCardItem,
            lItem,
            lCount = 0,
            lData,
            lLength,
            lDoDisplayCellPoints = veritracks.system.clientSetting('MapDisplayCellCentroids'),
            lFilterValue,
            lFilterArray,
            lKey;
        lEnrollee = getDataItem(aParams.EnrolleeId, 'Enrollees');
        if (isNullOrUndefined(lEnrollee)){
            lEnrollee = getDataItem(aParams.EnrolleeId, 'EnrolleesUniversal');
        }
        var lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId),
                    lEnrolleePosition = lIsInformatics? parseInt(aParams.TrackItem.index[aParams.TrackItem.index.length -1]):parseInt(aParams.IconClass[5]);
        FixDates(aData); 
        lData = aData;

        if (!lDoDisplayCellPoints) {
            lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('TrackTypeId', 2, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
            lData = query(lData, lBuilder.RootExpression);
        }

        lSort.addDescendingColumn('TrackDate');
        lData = lSort.sort(lData);

        lLength = lData.length;
        for (lCount = 0; lCount < lLength; lCount++) {
            lItem = lData[lCount];
            lCardItem = veritracks.enrollees.mapping.generateTrackpointCard(lItem, 4, lEnrollee, lEnrolleePosition);
            lCardItem.Name = 'Visit Point ' + (lCount + 1).toString() + ' of ' + lLength.toString();
            lCardList.push(lCardItem);
        }

        //veritracks.enrollees.mapping.data.VisitCardList = lCardList;
        veritracks.enrollees.mapping.AddToTotalVisitCardList(lCardList);

    }

    function onSuccess(aData) {
        "use strict";
        var lKey,
            lTempData,
            lBuilder = new SumoPredicateBuilder(),
            lFilterValue;

        for (lKey in mData) {
            if (mData.hasOwnProperty(lKey)) {
                mData[lKey].IsExpanded = true;
                FixDates(mData[lKey].TrackItem.data.Trackpoints);
                prepareSingleVisit(mData[lKey], mData[lKey].TrackItem.data.Trackpoints);
            }
        }

        lFilterValue = mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type');
        if (!isNullOrUndefined(lFilterValue) && lFilterValue.length > 0 && lFilterValue.indexOf(4) === -1) {
            lFilterValue.push('4');
            mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type', lFilterValue)
        }
        veritracks.enrollees.mapping.data.DoFitBounds = false;
        setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false);
        mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
    }
    function begin() {
        veritracks.enrollees.mapping.collapseVisits(false);
        mBuilder.Clear();
        mBuilder.AddNewExpressionConditional('VisitId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        mData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList);
        mData = query(mData, mBuilder.RootExpression);

        onSuccess(mData);
        mEnrolleesData.OffenderPastData = mData;
    }
    setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', true, begin);
}


veritracks.enrollees.mapping.expandAllVisitsOld = function () {
    "use strict";
    var mBuilder = new SumoPredicateBuilder(),
        mData,
        mCardList = [];

    mEnrolleesData.VisitsProcesssed = true;
    mEnrolleesData.OffenderPastData = null;

    function prepareSingleVisit(aParams, aData) {
        var lSort = new SortExpression(),
            lBuilder,
            lCardList = [],
            lEnrollee,
            lCardItem,
            lItem,
            lCount = 0,
            lData,
            lLength,
            lDoDisplayCellPoints = veritracks.system.clientSetting('MapDisplayCellCentroids'),
            lFilterValue,
            lFilterArray,
            lKey,
            lEnrolleePosition = parseInt(aParams.IconClass[5]);

        lEnrollee = getDataItem(aParams.EnrolleeId, 'Enrollees');
        FixDates(aData);
        lData = aData;


        if (isNullOrUndefined(lEnrollee))
            lEnrollee = getDataItem(aParams.EnrolleeId, 'EnrolleesUniversal');

        if (!lDoDisplayCellPoints) {
            lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('TrackTypeId', 2, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
            lData = query(lData, lBuilder.RootExpression);
        }

        lSort.addDescendingColumn('TrackDate');
        lData = lSort.sort(lData);

        lLength = lData.length;
        for (lCount = 0; lCount < lLength; lCount++) {
            lItem = lData[lCount];
            lCardItem = veritracks.enrollees.mapping.generateTrackpointCard(lItem, 4, lEnrollee, lEnrolleePosition);
            lCardItem.Name = 'Visit Point ' + (lCount + 1).toString() + ' of ' + lLength.toString();
            lCardList.push(lCardItem);
            // mCardList.push(lCardItem);
        }

        //veritracks.enrollees.mapping.data.VisitCardList = lCardList;
        veritracks.enrollees.mapping.AddToTotalVisitCardList(lCardList);

    }

    function onSuccess(aParams, aData) {
        "use strict";
        var lKey,
            lTempData,
            lBuilder = new SumoPredicateBuilder(),
            lFilterValue;
        if (!isNullOrUndefined(aParams))
            aData = aData.concat(aParams);
        FixDates(aData);

        for (lKey in mData) {
            if (mData.hasOwnProperty(lKey)) {
                mData[lKey].IsExpanded = true;
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('TrackDate', mData[lKey].TrackItem.data.StartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('TrackDate', mData[lKey].TrackItem.data.EndDate, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('EnrolleeId', mData[lKey].EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lTempData = query(aData, lBuilder.RootExpression);
                prepareSingleVisit(mData[lKey], lTempData);
            }
        }

        lFilterValue = mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type');
        if (!isNullOrUndefined(lFilterValue) && lFilterValue.length > 0 && lFilterValue.indexOf(4) === -1) {
            lFilterValue.push('4');
            mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.columnValue('Type', lFilterValue)
        }
        veritracks.enrollees.mapping.data.DoFitBounds = false;
        setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false);
        mEnrolleesControls.OffenderTrackpointDetailCardViewFilter.filter();
    }
    function begin() {
        var lKey,
            lLowestStartDate,
            lHighestEndDate,
            lCardToUse,
            lTotalTrackpoints = 0,
            lDateRange = offenderMapPopulate_GetDateRange(),
            lEndDate = new Date(lDateRange.endDate),
            lCleanArray = [];

        veritracks.enrollees.mapping.collapseVisits(false);
        mBuilder.Clear();
        mBuilder.AddNewExpressionConditional('VisitId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        mData = veritracks.enrollees.mapping.data.PrimaryCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList);
        mData = query(mData, mBuilder.RootExpression);
        for (lKey in mData) {
            if (mData.hasOwnProperty(lKey)) {
                lCleanArray.push(mData[lKey]);
            }
        }
        lLowestStartDate = lCleanArray[0].TrackItem.data.StartDate;
        lHighestEndDate = lCleanArray[0].TrackItem.data.EndDate;
        for (lKey in lCleanArray) {
            if (lCleanArray.hasOwnProperty(lKey)) {
                if (lLowestStartDate > lCleanArray[lKey].TrackItem.data.StartDate) {
                    lLowestStartDate = lCleanArray[lKey].TrackItem.data.StartDate;
                }
                if (lHighestEndDate < lCleanArray[lKey].TrackItem.data.EndDate) {
                    lHighestEndDate = lCleanArray[lKey].TrackItem.data.EndDate;
                }
            }
        }


        veritracks.mapping.visitExpandAllTrackpoints(lCleanArray[0], lLowestStartDate, lHighestEndDate, offenderMapPopulate_GetDateRange(), onSuccess);

        mEnrolleesData.OffenderPastData = mData;
    }
    setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', true, begin);
}

veritracks.enrollees.mapping.exportData = function () {
    "use strict";
    var lDataSource,
        lWriter = new XMLWriter('UTF-8', '1.0'),
        lNow = new Date(),
        lHtmlBuilder = [],
        lDetail = '',
        lNewWindow,
        lDocument,
        lHtml,
        lItem,
        lKey;

    lNow.addDays(2);
    if (mStateManager.Settings()[0] == 'Offenders') {
        lDataSource = mEnrolleesControls.OffenderTrackpointDetailCardView.getDataSource();
    } else {
        lDataSource = mEnrolleesControls.VictimTrackpointDetailCardView.getDataSource();
    }
    function buildDescription(aDataItem) {
        lHtmlBuilder = [];
        lHtmlBuilder.push('<![CDATA[ <div>');
        if (aDataItem.Type !== 6) {
            lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">Enrollee:</span> ');
            lHtmlBuilder.push(aDataItem.EnrolleeName);
            lHtmlBuilder.push('</div>');
        }
        lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">Track Type:</span> ');
        switch (aDataItem.Type) {
            case 1:
                lHtmlBuilder.push('Address');
                break;
            case 2:
                lHtmlBuilder.push('Zone');
                break;
            case 3:
                lHtmlBuilder.push('Visit');
                break;
            case 4:
                lHtmlBuilder.push('Visit Point');
                break;
            case 5:
                lHtmlBuilder.push('Track Point');
                break;
            case 6:
                lHtmlBuilder.push('Label');
                break;
            case 8:
                lHtmlBuilder.push('Cell Tower');
                break;
            case 9:
                lHtmlBuilder.push('Cell Track');
                break;
        }
        lHtmlBuilder.push('</div>');
        if (aDataItem.Date <= lNow) {
            lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">Track Date:</span> ');
            lHtmlBuilder.push(DisplayLongDateTime(aDataItem.Date));
            lHtmlBuilder.push('</div>');
        }
        if (aDataItem.Type === 2) {
            // zone
            lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">Center:</span> ');
        } else {
            lHtmlBuilder.push('<div><span style=\"font-weight:bold;\">Location:</span> ');
        }
        if (aDataItem.Latitude !== 0 && aDataItem.Longitude !== 0) {
            lHtmlBuilder.push(aDataItem.Latitude.toString());
            lHtmlBuilder.push(', ');
            lHtmlBuilder.push(aDataItem.Longitude.toString());
        } else {
            lHtmlBuilder.push('- unknown -');
        }
        lHtmlBuilder.push('</div>');
        if (aDataItem.ExtendedDetail !== '') {
            lDetail = aDataItem.ExtendedDetail;
            while (lDetail.indexOf('Ellipsis MapProperty Property') !== -1) {
                lDetail = lDetail.replace('class="Ellipsis MapProperty Property">', '><span style=\"font-weight:bold;\">');
            }
            while (lDetail.indexOf('PropertyTitle') !== -1) {
                lDetail = lDetail.replace('class="PropertyTitle">', '><span style=\"font-weight:bold;\">');
            }
            while (lDetail.indexOf(': ') !== -1) {
                lDetail = lDetail.replace(': ', ':</span> ');
            }
            while (lDetail.indexOf('NoIconProperty') !== -1) {
                lDetail = lDetail.replace('class=\"NoIconProperty\"', 'style=\"padding-left: 20px;\"');
            }
            lDetail = lDetail.replace('Open Events</div>', 'Open Events</span></div>');
            lHtmlBuilder.push(lDetail);
        }
        lHtmlBuilder.push('</div>]]>');
        return lHtmlBuilder.join('');
    }

    lWriter.writeStartDocument();

    lWriter.writeStartElement('kml');
    lWriter.writeAttributeString('xmlns', 'http://earth.google.com/kml/2.2');

    lWriter.writeStartElement('Document');

    // google specific styling
    lWriter.writeStartElement('Style');
    lWriter.writeAttributeString('id', 'oIcon');

    lWriter.writeStartElement('IconStyle');

    lWriter.writeStartElement('scale');
    lWriter.writeString('1.1');
    lWriter.writeEndElement();

    lWriter.writeStartElement('Icon');
    lWriter.writeStartElement('href');
    lWriter.writeString('/Resources/Images/Mapping/orange.png');
    lWriter.writeEndElement();
    lWriter.writeEndElement();

    lWriter.writeEndElement();

    lWriter.writeEndElement();

    for (lKey in lDataSource) {
        if (lDataSource.hasOwnProperty(lKey)) {
            lItem = lDataSource[lKey];
            lWriter.writeStartElement('styleUrl');
            lWriter.writeString('#oIcon');
            lWriter.writeEndElement();

            lWriter.writeStartElement('Placemark');

            lWriter.writeStartElement('name');
            lWriter.writeString(lItem.DisplayName);
            lWriter.writeEndElement();

            lWriter.writeStartElement('description');
            lWriter.writeString(buildDescription(lItem));
            lWriter.writeEndElement();

            lWriter.writeStartElement('Point');
            lWriter.writeStartElement('coordinates');
            lWriter.writeString(lItem.Longitude + ',' + lItem.Latitude + ',0');
            lWriter.writeEndElement();
            lWriter.writeEndElement();

            lWriter.writeEndElement();
        }
    }

    lWriter.writeEndElement();

    lWriter.writeEndElement();

    lWriter.writeEndDocument();

    lWriter.formatting = 'none';
    lHtml = lWriter.flush();
    veritracks.mapping.data.ExportData = veritracks.system.encodeHtml(lHtml);
    downloadKMLFile(lHtml);
};

veritracks.enrollees.mapping.onGeocode = function (aResult, aStatus, aParams) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lIsSuccess = false,
        lDataSource,
        lAddress,
        lCard;

    function trackpoint_OnFailure(aParams, a, b, c) {
        var l = '';
    }

    function trackpoint_OnSuccess(aParams, aData) {
        var l = '';
    }

    function address_OnFailure(aParams, a, b, c) {
        var l = '';
    }

    function address_OnSuccess(aParams, aData) {
        aParams.AddressId = aData.Id;
        WriteSingle(aParams, trackpoint_OnSuccess, trackpoint_OnFailure, null, true);
    }

    function format(aCard, aAddress, aIsGeocoded) {
        aCard.Address = aAddress;
        $('#uTrackpointAddress' + aCard.Id).text(aCard.Address).attr('title', aCard.Address);
        $('#uTrackpointDetailAddress' + aCard.Id).text(aCard.Address).attr('title', aCard.Address);
        aCard.IsGeocoded = aIsGeocoded;
    }

    function save(aAddress, lCard) {
        var lAddress = new Address(aAddress),
            lData = lCard.TrackItem.data;
        lAddress.AddressTypeId = 4;
        lAddress.Name = 'Trackpoint: ' + lData.Id + ' (street_address)';

        WriteSingle(lAddress, address_OnSuccess, address_OnFailure, lData, true);
    }

    if (aStatus === 'OK' && aResult) {
        lAddress = aResult;
        lDataSource = veritracks.enrollees.mapping.data.PrimaryCardList;
        lDataSource = lDataSource.concat(veritracks.enrollees.mapping.data.SecondaryCardList);
        lDataSource = lDataSource.concat(veritracks.enrollees.mapping.data.TagCardList);
        lBuilder.AddNewExpressionConditional('Id', aParams.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDataSource = query(lDataSource, lBuilder.RootExpression);

        lCard = lDataSource[lDataSource.length - 1];
        lIsSuccess = true;
    }
    if (isNullOrUndefined(lCard)) {
        lCard = aParams;
    }
    if (lIsSuccess) {
        format(lCard, lAddress.formated_address, true);
        //save(lAddress, lCard);
    } else {
        format(lCard, '- no address found -', false);
    }
};

veritracks.enrollees.mapping.setTravelToProfileLock = function () {
    "use strict";
    var lDateRange = offenderMapPopulate_GetDateRange(),
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem();

    if (!isNullOrUndefined(lEnrollee) && !isNullOrUndefined(lDateRange)) {
        mEnrolleesData.secondLockOnEnrolleeId = lEnrollee.Enrollee.Id;
        mEnrolleesData.secondLockDate = DisplayShortDateTime(lDateRange.endDate);
    }
}



var mEnrolleesMapMenuItems = [
    {
        text:'Create Enrollee Address',
        cssClass:'contextMenuClass-item',
        OnClick: function (latLng){
            enrolleeAddressEditGenerator(-1,-1,latLng);
        }
    },
    {
        text:'Create Label',
        cssClass:'contextMenuClass-item ',
        OnClick: function (latLng){
            MapPointOfInterestModal("label",latLng,mEnrolleesControls.EnrolleesMap);
        }
    },
    {
        text:'Create Area of Interest',
        cssClass:'contextMenuClass-item ',
        OnClick: function (latLng){
            MapPointOfInterestModal("AOI",latLng,mEnrolleesControls.EnrolleesMap);
        }
    }
];

veritracks.enrollees.mapping.contextMenu = new ContextMenu('uMapOffenderContextMenu',mEnrolleesMapMenuItems,{class:'contextMenuClass'});

var mEnrolleesMapMenuVisitItems = [
    {
        text:'Prior visits (this enrollee)',
        cssClass:'contextMenuClass-item',
        OnClick: function (latLng,e){
            PriorVisitEnrolleesModal('this',e,mEnrolleesControls.EnrolleesMap);
        }
    },
    {
        text:'Prior visits (all enrollees)',
        cssClass:'contextMenuClass-item',
        OnClick: function (latLng,e){
            PriorVisitEnrolleesModal('all',e,mEnrolleesControls.EnrolleesMap);
        }
    },
    {
        text:'Associations (this enrollee)',
        cssClass:'contextMenuClass-item',
        OnClick: function (latLng,e){
            VisitAssociationsModal('this',e,mEnrolleesControls.EnrolleesMap);
        }
    },
    {
        text:'Associations (all enrollees)',
        cssClass:'contextMenuClass-item ',
        OnClick: function (latLng,e){
            VisitAssociationsModal('all',e,mEnrolleesControls.EnrolleesMap);
        }
    },
    {
        text:'Mark Visit as known',
        cssClass:'contextMenuClass-item ',
        OnClick: function (latLng,e){
            MarkVisitAsKnownModal(e);
        }
    },
];
veritracks.enrollees.mapping.contextMenuVisit = new ContextMenu('uMapOffenderContextMenu',mEnrolleesMapMenuVisitItems,{class:'contextMenuClass'});

veritracks.enrollees.mapping.onClick = function (aEvent) {
    "use strict";
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));
    function onGeocode(aResult, aStatus, aParams) {
        var lResult,
            lHtml = [];
        if (aStatus === 'OK' && aResult) {
            lResult = Array.isArray(aResult)?aResult[0]:aResult;
            lHtml.push('<h3>Address</h3>');
            lHtml.push(lResult.formated_address);
            lHtml.push('<h3>Latitude</h3>');
            lHtml.push(lResult.geometry?lResult.geometry.location.lat():lResult.center_latitude);
            lHtml.push('<h3>Longitude</h3>');
            lHtml.push(lResult.geometry?lResult.geometry.location.lng():lResult.center_longitude);
            mEnrolleesControls.NotificationPanel.clearNotifications();
            mEnrolleesControls.NotificationPanel.addNotification(lHtml.join(''), true);
        }
    }

    if (veritracks.enrollees.mapping.data.DoDistanceCalculation) {
        if (lDoMetric) {
            enrolleesCalculateDistance(aEvent.latLng, new Unit().MEASURE.METRIC)
        }
        else {
            enrolleesCalculateDistance(aEvent.latLng);
        }
    } else if (veritracks.enrollees.mapping.data.DoAddHomeAddress) {
        enrolleesHomeAddressAdd(aEvent.latLng);
    } else if (veritracks.enrollees.mapping.data.DoGeocode) {
        if (veritracks.enrollees.mapping.data.DoGeocode) {
            enrolleesGeocodeToolBar_OnClick();
        }
        mEnrolleesControls.EnrolleesMap.geocode(aEvent.latLng.lat().toString() + ', ' + aEvent.latLng.lng().toString(), onGeocode, null);
    }
    if(veritracks.enrollees.mapping.contextMenu){
        veritracks.enrollees.mapping.contextMenu.hide(aEvent);

    }
    if(veritracks.enrollees.mapping.contextMenuVisit){
        veritracks.enrollees.mapping.contextMenuVisit.hide(aEvent);
    }
};
veritracks.enrollees.mapping.onRightClick = function(aEvent) {
    // Contains an Event Object
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
   
    if(lIsInformatics){
        veritracks.enrollees.mapping.contextMenu.show(aEvent);
    }
}
veritracks.enrollees.mapping.initializeEnrolleeMap = function () {
    var lArg = arguments[0];
    if (veritracks.enrollees.mapping.data.TimeChangeTimerId !== null) {
        window.clearTimeout(veritracks.enrollees.mapping.data.TimeChangeTimerId);
        veritracks.enrollees.mapping.data.TimeChangeTimerId = null;
    }

    function onTick() {
        if (mStateManager.Settings()[0] === 'Offenders') {
            offenderMapPopulate(lArg);
            if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId)) {
                offenderSecondaryMapPopulate();
            }
        } else {
            Victim.victimMapPopulate(lArg);
            if (!isNullOrUndefined(mEnrolleesData.VictimSecondaryCurrentId)) {
                offenderSecondaryVictimMapPopulate();
            }
        }
    }

    veritracks.enrollees.mapping.data.TimeChangeTimerId = window.setTimeout(onTick, 750);
}

veritracks.enrollees.mapping.readEnrolleeTimelineChart = function (aEnrolleeId, aStartDate, aEndDate, aParams, aCallback) {
    "use strict";
    /*if astart date is null assign a value*/
    var lStartDate,
        lEndDate,
        lEnrollee = GetEnrollee(aEnrolleeId);

    if (isNullOrUndefined(aStartDate)) {
        lStartDate = new Date();
    } else {
        lStartDate = aStartDate._d;
    }
    /*if aenddate is null assign a value*/
    if (isNullOrUndefined(aEndDate)) {
        lEndDate = new Date();
    } else {
        lEndDate = aEndDate._d;
    }

    lStartDate = FixSentDate(lStartDate, lEnrollee);
    lEndDate = FixSentDate(lEndDate, lEnrollee);

    if (GetEnrolleeCardProductIdTimelineSupport()) {
        veritracks.data.controller.readEnrolleeTimeline(aEnrolleeId, lStartDate, lEndDate, false, enrolleeTimeline_OnSuccess, enrolleeTimeline_OnFailure, null);
    } else {
        aCallback([]);
    }

    function enrolleeTimeline_OnSuccess(aParams, aData) {
        var lBuilder = new SumoPredicateBuilder();
        var lMasterBuilder = new SumoPredicateBuilder();
        var lChildBuilder = new SumoPredicateBuilder();
        var lSort = new SortExpression();
        var lChartGroupings = [];
        var enrolleeGroup = new EnrolleeChartGrouping();
        var lData = aData; 
 
        var lEventDetail = new EventDetailList();
        if (aData.length > 0) {
            FixDates(aData);
            lSort.addAscendingColumn('StartDateUTC');
            aData = lSort.sort(aData);

            // grouping by match type -- ordered by Year + Month + MonthDay + Hour24 + Minute
            // next 

           // FixVisitNotLabeled(aData);

            
            for (var i = 0; i < aData.length; i++) {
                if (enrolleeGroup.MatchType == '') {
                    enrolleeGroup.StartDate = moment(aData[i].StartDateUTC)._d;
                    enrolleeGroup.MatchType = aData[i].MatchType;
                    enrolleeGroup.Title = aData[i].Title;
                    enrolleeGroup.TimelineData = aData[i];
                }
                else {
                    // matches to next one should be skipped only if they dont match should the previous one be grabbed and that grouping be completed
                    if (aData[i].Title != enrolleeGroup.Title && aData[i].MatchType != enrolleeGroup.MatchType && aData[i].StopDateUTC != aData[i - 1].StopDateUTC || (aData[i].StartDateUTC != aData[i - 1].StopDateUTC && aData[i].StopDateUTC != aData[i - 1].StopDateUTC)) {
                        enrolleeGroup.StopDate =moment(aData[i - 1].StopDateUTC)._d;
                        lChartGroupings.push(enrolleeGroup);
                        // begin next grouping
                        enrolleeGroup = new EnrolleeChartGrouping();
                        enrolleeGroup.StartDate = moment(aData[i].StartDateUTC)._d;
                        enrolleeGroup.MatchType = aData[i].MatchType;
                        enrolleeGroup.Title = aData[i].Title;
 
                        enrolleeGroup.TimelineData = aData[i];
                    }
                }
            }


            //close last grouping
            if (aData[aData.length - 1].MatchType.indexOf("In Progress") >= 0) {
                var lLastContact = getDataItem(mEnrolleesData.OffenderCurrentId, 'EnrolleeLastContact');
                enrolleeGroup.StopDate = moment(lLastContact.TrackDate)._d;
                enrolleeGroup.TimelineData.Latitude = lLastContact.Latitude;
                enrolleeGroup.TimelineData.Longitude = lLastContact.Longitude;
            } else {
                enrolleeGroup.StopDate = aData[aData.length - 1].StopDate;
            }
            lChartGroupings.push(enrolleeGroup);


            // add no contact areas
            var lDeepCopyChartGrouping = $.extend(true, [], lChartGroupings);
            for (var i = 0; i < lDeepCopyChartGrouping.length; i++) {
                var lFirstGroup = lDeepCopyChartGrouping[i];
                var lNextGroup = lDeepCopyChartGrouping[i + 1];

                if (i == 0) {
                    if (moment(lStartDate) < moment(lFirstGroup.StartDate).add(-10, 'minutes')) {
                        enrolleeGroup = new EnrolleeChartGrouping();
                        enrolleeGroup.StartDate = moment(lStartDate)._d;
                        enrolleeGroup.StopDate = moment(lFirstGroup.StartDate).add(-1, 'seconds')._d
                        enrolleeGroup.MatchType = 'No Location Area';
                        enrolleeGroup.Title = '';
                        lChartGroupings.push(enrolleeGroup);
                    }
                }
                if (lNextGroup && moment(lFirstGroup.StopDate) < moment(lNextGroup.StartDate).add(-10, 'minutes')) {
                    enrolleeGroup = new EnrolleeChartGrouping();
                    enrolleeGroup.StartDate = moment(lFirstGroup.StopDate).add(1, 'seconds')._d;
                    enrolleeGroup.StopDate = moment(lNextGroup.StartDate).add(-1, 'seconds')._d
                    enrolleeGroup.MatchType = 'No Location Area';
                    enrolleeGroup.Title = '';
                    lChartGroupings.push(enrolleeGroup);
                } else {
                    if (lNextGroup) {
                        if (moment(lFirstGroup.StopDate) < moment(lNextGroup.StartDate).add(-60, 'seconds')) {
                            if (lChartGroupings[i].TimelineData.PointGroupId !== -1 && lChartGroupings[i].TimelineData.MatchType != "In Motion (i.e., Trip)") {
                                lChartGroupings[i].PotentialTrip = true;
                            }
                        }
                        lChartGroupings[i].StopDate = moment(lNextGroup.StartDate).add(-1, 'seconds');
                    }
                }

                if (i == lDeepCopyChartGrouping.length - 1 && lFirstGroup.MatchType.indexOf('In Progress') == -1) {
                    if (moment(lEndDate) > moment(lFirstGroup.StopDate).add(10, 'minutes')) {
                        enrolleeGroup = new EnrolleeChartGrouping();
                        enrolleeGroup.StartDate = moment(lFirstGroup.StopDate).add(1, 'seconds')._d;

                        if (moment(lEndDate) > moment()) {
                            enrolleeGroup.StopDate = moment()._d
                        } else {
                            enrolleeGroup.StopDate = moment(lEndDate)._d
                        }

                        enrolleeGroup.MatchType = 'No Location Area';
                        enrolleeGroup.Title = '';
                        lChartGroupings.push(enrolleeGroup);
                    }
                }
            }

        } else {
            enrolleeGroup = new EnrolleeChartGrouping();
            enrolleeGroup.StartDate = moment(lStartDate)._d;
            
            if(moment(lEndDate) > moment()){
                enrolleeGroup.StopDate = moment()._d
            }else{
                enrolleeGroup.StopDate = moment(lEndDate)._d
            }
            enrolleeGroup.MatchType = 'No Location Area';
            enrolleeGroup.Title = '';
            lChartGroupings.push(enrolleeGroup);
        }

        var lSort = new SortExpression();
        lSort.addAscendingColumn('StartDate');
        lChartGroupings = lSort.sort(lChartGroupings);

        // leave this for later.
        if (gUserDetails.Role == 2) {
            eventHistoryChart_onSuccess(lChartGroupings, []);
        } else {
            //lBuilder.Clear();
            //lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            //lBuilder.AddNewExpressionConditional('StartDateUTC', lChartGroupings[lChartGroupings.length - 1].StopDate, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
            //lBuilder.AddNewExpressionConditional('MetaEventId', [1, 10, 13, 16, 20, 63, 196, 371, 383, 1003], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            //lChildBuilder.AddNewExpressionConditional('StopDateUTC', lChartGroupings[0].StartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.Or());
            //lChildBuilder.AddNewExpressionConditional('IsOpen', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());

            //lBuilder.Concatenate(lChildBuilder, mLogicalOperatorEnum.And());

            //ReadMultiple(gObjectList.EventHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, eventHistoryChart_onSuccess, eventHistoryChart_OnFail, lChartGroupings, null, 0, true);
            veritracks.data.controller.readEnrolleeEvents(aEnrolleeId, lChartGroupings[0].StartDate, lChartGroupings[lChartGroupings.length - 1].StopDate, [1, 10, 13, 16, 20, 63, 196, 371, 383, 1003], eventHistoryChart_onSuccess, eventHistoryChart_OnFail, lChartGroupings);
        }
    }

    function enrolleeTimeline_OnFailure() {
    }

    function eventHistoryChart_onSuccess(aParams, aData) {

        getEnrolleeAssociationMatches(aEnrolleeId, finalizeTimelineData, { 'Groupings': aParams, 'Events': aData });
    }

    function finalizeTimelineData(aParams, aData) {
        var lChartGroupings = aParams.Groupings;
        var lEvents = aParams.Events;
        var lTimeZone = getEnrolleeTimeZone(aEnrolleeId);
        var lSort = new SortExpression();
        var lTimelineData = [];
        var lBuilder = new SumoPredicateBuilder();

        FixDates(lEvents);
        lSort.addAscendingColumn('StartDateUTC');

        lEvents = lSort.sort(lEvents);

        if (aData.hasOwnProperty('Data')) {
            aData = aData.Data;
        }

        for (var i = 0; i < lChartGroupings.length; i++) {
            var lGroup = lChartGroupings[i];
            if (lGroup.TimelineData && lGroup.TimelineData.PointGroupId != -1) {
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('PointGroupingId', lGroup.TimelineData.PointGroupId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lGroup.Associations = query(aData, lBuilder.RootExpression);
                if (!lGroup.Associations) {
                    lGroup.Associations = [];
                }

            }
            for (var lKey in lEvents) {
                if (lEvents.hasOwnProperty(lKey)) {
                    if ((moment(lGroup.StartDate) <= moment(lEvents[lKey].StartDateUTC) && moment(lGroup.StopDate) >= moment(lEvents[lKey].StartDateUTC))
                        || (moment(lGroup.StartDate) <= moment(lEvents[lKey].StopDateUTC) && moment(lGroup.StopDate) >= moment(lEvents[lKey].StopDateUTC))
                        || (moment(lEvents[lKey].StartDateUTC) <= moment(lGroup.StartDate) && moment(lEvents[lKey].StopDateUTC) >= moment(lGroup.StartDate))
                        || (moment(lEvents[lKey].StartDateUTC) <= moment(lGroup.StartDate) && lEvents[lKey].IsOpen)) {
                        lGroup.EventList.push(lEvents[lKey]);
                    }
                }
            }
            lTimelineData.push(new fullCalendarChartingObject(lTimeZone, lGroup));
        }

        if (aCallback) {
            aCallback(lTimelineData);
        }
        $('.loadingGif').hide();
    }

    function eventHistoryChart_OnFail() {
    }

}

function getEnrolleeAssociationMatches(aEnrolleeId, aCallback, aParams) {
    "use strict";
    var lPermission = CheckUserHasPermission(45) ? 1 : 0;
    var lEnrollee = getDataItem(aEnrolleeId, 'Enrollees');
    var lIsInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }   
    var lAssociationsDisabled = veritracks.system.clientSetting("associationdisabled");
    if (lIsInformatics || !lAssociationsDisabled) {
        veritracks.mapping.getEnrolleeAssociations(aEnrolleeId, lPermission, aCallback, Sad, aParams);
    } else {
        aCallback(aParams, []);
    }
}

VeritracksAgentOffenderMapTimeManagement = function (enrolleeId) {
    this.finished = false;
    var enrolleeId = enrolleeId;
    var start, end;

    this.startTime = function () {
        if (!start) {
            start = new Date()
        }
        return start
    }

    this.endTime = function () {
        if (!end) {
            end = new Date()
        }
        return end
    }

    this.finish = function () {
        if (!this.finished) {
            this.endTime();
            this.finished = true;

            var lAgentsStopCheck = getDataItem(gUserDetails.UserId, 'Users');

            if (lAgentsStopCheck) {
                // ORI
                var ORIPropertyTrackReview = veritracks.enrollees.mapping.ORIFlag();
                if (ORIPropertyTrackReview == 'N'){
                    // no track at all  return; 
                    return; 
                } else if(ORIPropertyTrackReview == 'R'){
                    //  Recording  
                    // only prevents to record when the Lock button is clicked
                    var lLockData = veritracks.enrollees.mapping.getMapTimeLockTrackingState(); 
                    if(!lLockData.lock && !lLockData.tracking || lLockData.lock && !lLockData.tracking ){
                        return;
                    }
                } else if(ORIPropertyTrackReview != 'Y'){
                    // block anythng else
                    return;
                }
                // Automatically ( no click control at ALL)
                var lTrackCount = CalculateTrackpointCount();
                var lVisitCount = CalculateVisitCount();
                var lCardCount = 0;
                if (!isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView)) {
                    lCardCount = mEnrolleesControls.OffenderTrackpointDetailCardView.getDataSource().length;
                    //if card view is not empty get gps points only
                    if (lCardCount > 0) {
                        lCardCount = lVisitCount.Count + lTrackCount;
                    }
                }
                var lUserTransaction = new UserTransaction();
                var lUserTransactionValue = new UserTransactionValue();
                var lUserTransactionValuesList = [];

                lUserTransaction.EnrolleeId = enrolleeId;
                lUserTransaction.TypeId = 5;
                lUserTransaction.DisplayId = gUserDetails.UserId;
                lUserTransaction.TransactionStartDate = start;
                lUserTransaction.TransactionStopDate = end;
                lUserTransaction.TrackPointCount = lCardCount;
                
                WriteSingle(lUserTransaction, null,Sad, null, true)
            }
            
        }
    }

    this.startTime()
}

function openMapPrintWindow() {
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    window.open('Enrollees.Offenders.Map.Print.htm?token=' + lSecurityToken, 'Veritracks Enrollee Track', 'token=' + lSecurityToken);
}

/**
 * 
 * @returns boolean
 */
function IsAutoZoomEnabled(){
    return !!veritracks.system.clientSetting("AutoZoomFromTheMap");
}